import React, { Component, createRef } from "react";
import "../Sales.css";
import HeaderTools from "../../../PageComponents/Header/HeaderTools";
import { MDBInput } from "mdb-react-ui-kit";
import Select, { components } from "react-select";
import Switch from "react-switch";
import apiService from "../../../Services/apiServices";
import SaleModel from '../../../Models/Sale';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'
import { useToasts } from 'react-toast-notifications';
import globals from "../../../Services/globals";
import SaleAddPartner from "../../../PageComponents/UI/Modal/SaleAddPartner";
import calculate from "../../../Services/calculate";
import Search from "../../../PageComponents/Search/Search";
import LoaderComponent from "../../../PageComponents/UI/Components/LoaderComponent";
import SelectByGroup from "../../../PageComponents/UI/Inputs/SelectByGroup";
import helper from "../../../Services/helper";
import PaymentSales from "./PaymentSales";
//import {  fileToAtach } from "./atach111.pdf";
import { pdf } from '@react-pdf/renderer';
import Invoice4 from "../../../PageComponents/PDF/invoice4";
import InvoiceDocument1 from "../../../PageComponents/PDF/InvoiceDocument1";
import InvoiceDocument2 from "../../../PageComponents/PDF/InvoiceDocument2";
import InvoiceDocument3 from "../../../PageComponents/PDF/InvoiceDocument3";
import InvoiceDocument4 from "../../../PageComponents/PDF/InvoiceDocument4";
import InvoiceDocument5 from "../../../PageComponents/PDF/InvoiceDocument5";
import ExcelExport from "../../../PageComponents/Excel/ExcelExport";
import Print from "../../../PageComponents/Print/Print";
import { reference } from "@popperjs/core";

function withToast(Component) {
  return function WrappedComponent(props) {
    const toastFuncs = useToasts()
    return <Component {...props} {...toastFuncs} />;
  }
}


class Sale extends Component {

  constructor(props) {
    super(props);
    this.excelExportRef = createRef();
    this.printRef = createRef();
    this.state = {
      sale: new SaleModel(),
      saleDetails: [{
        no: 1, date: new Date(), comment: "", description: "", id: 0, itemId: 0, itemName: helper().translate("CHOOSE"), barcode: helper().translate("CHOOSE_BARCODE"), quantity: parseInt((this.props.location.search).substring(1, this.props.location.search.length)) === 4 ? -1 : 1,
        price: 0.0, avgPrice: "0", vat: 0, vatForm: 0, vatSum: 0, projectId: 0, addButton: true, validate: true, cityId: 0
      }],
      payment: [{ name: "to be paid", inputValue: 0 }, { name: "cash", inputValue: 0, objective: "pay" }, { name: "pos1", bankId: 0, inputValue: 0, objective: "pay", disabled: false }, { name: "pos2", bankId: 0, inputValue: 0, objective: "pay", disabled: false }, { name: "pos3", bankId: 0, inputValue: 0, objective: "pay", disabled: false }, { name: "totalPayment", inputValue: 0 }, { name: "remainingDebt", inputValue: 0 }, { name: "returnMoney", inputValue: 0 }],
      paymentBtn: { showPayFrom: false, showPayments: false, pay: false, savePayment: false },
      otherSalesDetails: false,
      paymentSales: [],
      defaultAccount: { defaultCashAccount: 0, defaultBankAccount: 0 },
      banksPos: [],
      warehouse: [],
      branches: [],
      partners: [],
      partnersFull: [],
      salesType: [],
      loader: true,
      settings: [],
      items: [],
      fullItems: [],
      projects: [],
      currentUserCashBoxId: 0,
      units: [],
      vatLevel: [],
      payMethod: [],
      saleVatTypes: [],
      invoiceIdFormat: true,
      allowMultipleDiscount: false,
      validate: false,
      partnerShow: false,
      userSettings: '',
      logedInUser: globals().getLogedInUser(),
      itemSaleOtherDetails: [{
        no: 1, id: 0, paymentsInfo: "", quantity: 1,
        priceForUnit: 0.0, totalPrice: 0, addButton: true, validate: true, editMode: false
      }],
      saveSaleOtherDetails: false,
      totalOtherDetails: 0,
      userColumns: [],
      columns: [],
      uncheckedHdrs: [],
      showedHeaders: [],
      showHiddeBox: false,
      isSending: false,
      cities:  []
    };
    this.formName = 'SaleDetails';
    this.withVatChanged = this.withVatChanged.bind(this);
    this.withCashPayment = this.withCashPayment.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this.rowClickOtherDetails = this.rowClickOtherDetails.bind(this);
    // this.search = this.search.bind(this);
    this.headers = [
      { key: helper().translate('PROJECT') },
      { key: helper().translate('UNIT') },
      { key: helper().translate('QUANTITY') },
      { key: helper().translate('DISCOUNT') },
      { key: helper().translate('VAT_FORM') },
      { key: helper().translate('DESCRIPTION') },
      { key: helper().translate('LOCATION') },
      { key: helper().translate('COMMENT') },
    ]
  }

  componentDidMount() {
    apiService().get('warehouses').then((response) => {
      if (response.success) {
        this.setState({ warehouse: response.data });
      } else {
        console.log('Error:' + response.errorMessage);
      }
    });

    var saleId = this.props.match.params.id;
    if (saleId > 0) {
      this.getSaleDetails(saleId);
      this.getOtherDetails(saleId);
      this.getDefaultCashAccount();
      this.getDefaultBankAccount();
      this.getInvoiceGenerateNumberSettings();


    } else if (saleId == 0) {
      let saleTypeId = parseInt((this.props.location.search).substring(1, this.props.location.search.length))
      this.getSaleType(saleTypeId)
      this.getWithWatSettings();
      this.getDefaultCashAccount();
      this.getDefaultBankAccount();
      this.getInvoiceGenerateNumberSettings();
    }

    apiService().query('getProjects').then((response) => {
      if (response.success) {
        this.setState({ projects: response.data });
      } else {
        console.log('Error:' + response.errorMessage);
      }
    });

    apiService().query('getCities', 'countryId=110').then((response) => {
      if (response.success) {
        this.setState({ cities: response.data });
      } else {
        console.log('Error:' + response.errorMessage);
      }
    });

    apiService().query('getBanksPos').then((response) => {
      if (response.success) {
        this.setState({ banksPos: response.data });
      } else {
        console.log('Error:' + response.errorMessage);
      }
    });

    apiService().get('salesType').then((response) => {
      if (response.success) {
        let data = response.data.filter(r => r.id != 13);
        data.forEach(e => {
          e.tokenName = e.name,
            e.name = helper().translate(`${e.name}`)
        });
        this.setState({ salesType: data });
        if (this.props.match.params.id == 0) {
          var sale = this.state.sale;
          sale.salesTypeId = parseInt((this.props.location.search).substring(1, this.props.location.search.length));
          this.setState(sale);
        }
      } else {
        console.log('Error:' + response.errorMessage);
      }
    });

    apiService().get('branches')
      .then((response) => {
        if (response.success) {
          let records = response.data;
          this.setState({ branches: records });
        }
      });

    apiService().get('units').then((response) => {
      if (response.success) {
        this.setState({ units: response.data });
      } else {
        console.log('Error:' + response.errorMessage);
      }
    });
    let currentUser = globals().getLogedInUser().data.username;
    apiService().query('user', 'userName=' + currentUser)
      .then((response) => {
        if (response.success) {
          let cashBox = response.data[0].cashBoxId;
          this.setState({ currentUserCashBoxId: cashBox });

        } else {
          console.log('Error: getting user cashbox' + response.errorMessage);
        }
      });


    if (saleId > 0) {
      apiService().query('getSale', 'id=' + saleId)
        .then((response) => {
          if (response.success) {

            var data = response.data[0];
            data.date = new Date(data.date)
            data.totalSum = data.totalSum + data.vatSum;
            data.subTotal = data.totalSum - data.vatSum;
            let saleCopy = new SaleModel(data);
            globals().getSettings().then((response) => {
              saleCopy.allowLackItems = response.allowLackItems;
              saleCopy.hideOrShowLackItems = response.hideOrShowLackItems;
            });
            this.getSaleType(data.salesTypeId)
            this.setState({ sale: saleCopy });
            this.getPaymentSales(saleId);
            this.getItems(data.partnerId, data.warehouseId, true);

          } else {
            console.log('Error:' + response.errorMessage);
          }
        });
    }

    apiService().get('vatLevel').then((response) => {
      if (response.success) {
        this.setState({ vatLevel: response.data });
      } else {
        console.log('Error:' + response.errorMessage);
      }
    });
    this.getSettings()
    this.getUserSettings()
    //this.getPartners();
    this.getUserColumns();
  }


  getSettings = () => {
    globals().getSettings().then((response) => {
      if (response) {
        let settings = response;
        this.setState({
          settings: settings,
          invoiceForm: settings.invoiceForm,
          allowMultipleDiscount: settings.allowMultipleDiscount
        });
      }
    })
  }
  getSaleType = async (id) => {
    apiService().query('getSaleVatType', 'saleType=' + id)
      .then((response) => {
        if (response.success) {
          this.setState({
            saleVatTypes: response.data
          });
          // setPurchase({warehouseId: cb?.warehouseId})
        }
        else alert('errr')
      })
  }

  getUserSettings = () => {
    globals().getUserSettings(this.state.logedInUser).then((response) => {
      this.setState({
        userSettings: response
      })
      this.setState({
        sale: {
          ...this.state.sale,
          warehouseId: response.warehouseId,
        },
      });
      this.getPartners();
    });
  }
  isitExport = () => {
    let check = this.state.sale;
    if (check.salesTypeId != 2 && check.salesTypeId != 9 && check.salesTypeId != 11 && check.salesTypeId != 12) {
      return true
    } else {
      return false
    }
  }

  notAllowedVatForm = () => {
    let check = this.state.sale;
    if (check.salesTypeId != 6 && check.salesTypeId != 7 && check.salesTypeId != 10 && check.salesTypeId != 11 && check.salesTypeId != 12) {
      return true
    } else {
      return false
    }
  }

  isOnlyExport = () => {
    let check = this.state.sale;
    if (check.salesTypeId == 2) {
      return true
    } else {
      return false
    }
  }


  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (parseInt((this.props.location.search).substring(1, this.props.location.search.length)) !== parseInt((prevProps.location.search).substring(1, prevProps.location.search.length))) {
      if (this.props.match.params.id == 0) {
        var sale = this.state.sale;
        sale.salesTypeId = parseInt((this.props.location.search).substring(1, this.props.location.search.length));
        this.setState(sale);
      }
    }
  }
  getPartners = (incWarehouseVal = this.state.userSettings.warehouseId) => {
    apiService().query('getPartners').then((response) => {
      if (response.success) {
        if (incWarehouseVal) {
          var cimi = this.state.warehouse?.find(ware => ware.id == incWarehouseVal)?.branchId;
          var dataFilter = response.data.filter(i => i.status === 1 && (i.partnerBranchId !== null && i.partnerBranchId === cimi || i.partnerBranchId === null));
          var partnersFull = response.data;
        } else {
          var dataFilter = response.data.filter(i => i.status === 1 && (i.partnerBranchId !== null && parseInt(i.partnerBranchId) === this.state.userSettings.branchId || i.partnerBranchId === null));
          var partnersFull = response.data;
        }

        // let dataFilter = response.data.filter(i => i.status === 1);
        let firstItem = { id: null, companyName: helper().translate("BUYER") + ":", saveAs: helper().translate("SAVED_AS") + ":", fiscalNo: helper().translate("FISCAL_NUMBER") + ":", cityName: helper().translate("CITY") + ":", isDisabled: true };
        dataFilter.unshift(firstItem)
        partnersFull.unshift(firstItem)
        this.setState({ partners: dataFilter, partnersFull: partnersFull });
      } else {
        console.log('Error:' + response.errorMessage);
      }
    });
  }

  getPaymentSales = (saleId) => {
    let saleArr = this.state.sale;
    apiService().query('getPaymentSales', "saleId=" + saleId).then((response) => {
      if (response.success) {
        var data = response.data;
        let totalPayment = 0;
        data.forEach(i => { totalPayment = totalPayment + parseFloat(i.amountPaid) });
        let amountLeft = (parseFloat(saleArr.totalSum) - parseFloat(totalPayment));
        saleArr.totalSalePayment = totalPayment;
        saleArr.amountLeft = amountLeft;
        this.setState({ sale: saleArr });
      }
    })
  }

  getItems = async (partnerId, warehouseId, isUpdated) => {
    try {
      const params = `&partnerId=${encodeURIComponent(partnerId)}&warehouseId=${encodeURIComponent(warehouseId)}`;
      const response = await apiService().query('rptGetItemsWithDiscount', params);

      if (!response?.success) return;

      const t = (k) => helper().translate(k);
      const header = {
        id: 0,
        itemName: `${t("ITEM")}:`,
        barcode: `${t("BARCODE")}:`,
        quantity: `${t("QUANTITY")}:`,
        avgPrice: `${t("PURCHASE_PRICE_WITH_VAT")}:`,
        priceWithVat: `${t("SALE_PRICE_WITH_VAT")}:`,
        isDisabled: true
      };

      const fullItems = Array.isArray(response.data) ? response.data : [];
      const { sale } = this.state || {};
      const saleType = sale?.salesTypeId;

      const baseItems = (!sale?.hideOrShowLackItems && saleType !== 7 && saleType !== 12)
        ? fullItems.filter(i => (i.quantity > 0) || (i.service === true))
        : fullItems;

      let filtered;
      if (saleType === 8 || saleType === 9) {
        filtered = baseItems.filter(i => i.inventoryItem === true && i.expired === false);
      } else if (saleType === 7 || saleType === 12) {
        filtered = baseItems.filter(i => i.expense === false && i.expired === false);
      } else {
        filtered = baseItems.filter(i => i.expense === false && i.inventoryItem === false && i.expired === false);
      }

      const items = [header, ...filtered];

      this.setState({ fullItems, items });
    } catch (err) {
      console.error("getItems error:", err);
    }
  };

  getWithWatSettings = (sType) => {
    globals().getSettings().then((response) => {
      if (response) {
        let data = response;
        let saleArr = new SaleModel();
        saleArr.salesTypeId = sType ? sType : parseInt((this.props.location.search).substring(1, this.props.location.search.length));
        // if(saleArr.salesTypeId != 2){
        //   saleArr.withVat = data.withVat;
        // }else{
        //   saleArr.withVat = true
        // }
        saleArr.withVat = true
        saleArr.withCashPayment = false;
        saleArr.subTotal = 0;
        saleArr.warehouseId = data.warehouseId;
        saleArr.allowLackItems = data.allowLackItems;
        saleArr.hideOrShowLackItems = data.hideOrShowLackItems;
        this.setState({ sale: saleArr })
        this.getUser();
      } else {
        alert('Error: 3' + response.errorMessage);
      }
    })
  }

  getAllowLackItemsSettings = () => {
    globals().getSettings().then((response) => {
      if (response) {
        let data = response;
        let saleArr = this.state.sale;
        saleArr.allowLackItems = data.allowLackItems;
        saleArr.hideOrShowLackItems = data.hideOrShowLackItems;
        this.setState({ sale: saleArr })
      } else {
        alert('Error: 2' + response.errorMessage);
      }
    })
  }

  getInvoiceGenerateNumberSettings = () => {
    globals().getSettings().then((response) => {
      if (response) {
        let saleArr = this.state.sale;
        let data = response;
        let invoiceFormat;
        if (data.autoGenerateInvoiceNumber === false) {
          invoiceFormat = false;
          saleArr.invoiceFormat = false;
        } else {
          invoiceFormat = true;
          saleArr.invoiceFormat = true;
        }
        this.setState({ invoiceIdFormat: invoiceFormat });
        this.setState({ sale: saleArr });
      } else {
        alert('Error: 1' + response.errorMessage);
      }
    })
  }
  getUser = () => {
    apiService().query('user', 'userName=' + globals().getLogedInUser().data.username)
      .then((response) => {
        if (response.success) {
          let saleArr = this.state.sale;
          saleArr.warehouseId = response.data[0].warehouseId;
          saleArr.cashBoxId = response.data[0].cashBoxId;
          this.setState({ sale: saleArr })
          this.setState({ loader: false })
        }
        else alert('errr')
      })
  }

  getDefaultCashAccount = () => {

    apiService().query('getDefaultAccount', 'name=' + "Accounts_Receivable")
      .then((response) => {
        if (response.success) {

          let defaultAcc = this.state.defaultAccount;
          defaultAcc.defaultCashAccount = response.data[0].accountId;
          this.setState({ defaultAccount: defaultAcc });
        } else {
          console.log('Error: getting default cash account' + response.errorMessage);
        }
      });
  }

  getDefaultBankAccount = () => {

    apiService().query('getDefaultAccount', 'name=' + "Accounts_Receivable")
      .then((response) => {
        if (response.success) {
          let defaultAcc = this.state.defaultAccount;
          defaultAcc.defaultBankAccount = response.data[0].accountId;
          this.setState({ defaultAccount: defaultAcc });
        } else {
          console.log('Error:getting default bank account' + response.errorMessage);
        }
      });
  }
  saleTypeChange = () => {
    if (this.props.match.params.id == 0) {
      var sale = this.state.sale;
      sale.salesTypeId = parseInt((this.props.location.search).substring(1, this.props.location.search.length));
      this.setState(sale)
    }
  }

  getSaleDetails = (saleId) => {
    apiService().query('getSaleDetails', "saleId=" + saleId).then((response) => {
      if (response.success) {
        this.getAllowLackItemsSettings();
        var data = response.data;
        if (data.length === 0) {
          data = [{
            no: 1, id: 0, date: new Date(), comment: "", itemId: 0, itemName: 'select item', barcode: 'select barcode', quantity: 1,
            price: 0.0, vat: 0, vatForm: 0, vatSum: 0, addButton: true, validate: true
          }];
        }
        var count = 1;
        data.forEach(i => { i.no = count; count++, i.initialQuantity = i.quantity, i.initialUnchangedQty = i.quantity, i.date = new Date(i.date) });
        for (var i = 0; i < data.length; i++) {
          if (i === (data.length - 1)) {
            data[i].addButton = true;

          }
          if (data[i].discount > 0 || data[i].discount2 > 0 || data[i].discount3 > 0 || data[i].discount4 > 0) {

            data[i].priceDiscount = calculate().calculateSale('priceMultipleDiscount')(data[i].price, data[i].discount, data[i].discount2, data[i].discount3, data[i].discount4);
            data[i].priceTvsh = calculate().calculateSale('priceTvsh')(data[i].priceDiscount, data[i].vat);
            data[i].totalPrice = calculate().calculateSale('totalPrice')(data[i].priceDiscount, data[i].quantity);
            // data[i].totalPriceTvsh= calculate().calculateSale('totalPriceTvsh')(data[i].totalPrice,data[i].vat);//1
            data[i].totalPriceTvsh = (data[i].totalPrice + data[i].vatSum);
            data[i].validate = true;
            // data[i].totalPriceItemTvsh= calculate().calculateSale('totalPriceItemTvsh')(data[i].totalPriceTvsh , data[i].quantity);

          } else {

            data[i].priceDiscount = data[i].price;
            data[i].priceTvsh = calculate().calculateSale('priceTvsh')(data[i].price, data[i].vat);
            data[i].totalPrice = calculate().calculateSale('totalPrice')(data[i].price, data[i].quantity);
            // data[i].totalPriceTvsh= calculate().calculateSale('totalPriceTvsh')(data[i].totalPrice,data[i].vat);//1
            data[i].totalPriceTvsh = (data[i].totalPrice + data[i].vatSum);
            data[i].validate = true;
            // data[i].totalPriceItemTvsh= calculate().calculateSale('totalPriceItemTvsh')(data[i].totalPriceTvsh , data[i].quantity);

          }
        }
        this.setState({ saleDetails: data });
        this.setState({ loader: false });
      } else {
        console.log('Error:' + response.errorMessage);
      }
    });
  }

  getOtherDetails = (saleId) => {
    apiService().query('getOtherSaleDetails', "saleId=" + saleId).then((response) => {
      // console.log(response)
      if (response.success) {
        var data = response.data;
        if (data.length === 0) {
          data = [{
            no: 1, id: 0, saleId: parseInt(saleId), paymentsInfo: "", quantity: 1,
            priceForUnit: 0.0, totalPrice: 0, addButton: true, validate: true
          }]
        }
        var count = 1;
        data.forEach(i => { i.no = count; count++ });
        for (var i = 0; i < data.length; i++) {
          if (i === (data.length - 1)) {
            data[i].addButton = true;
          }
        }
        this.setState({ itemSaleOtherDetails: data });
        this.otherTotalsDetails(data)
      } else {
        console.log('Error:' + response.errorMessage);
      }
    });
  }


  saleDetailsFirstItem = () => {
    var saleId = this.props.match.params.id;
    var sDetails = this.state.saleDetails;
    if (saleId == 0) {
      sDetails = [{
        no: 1, id: 0, itemId: 0, itemName: 'select item', barcode: 'select barcode', quantity: 1,
        price: 0.0, vat: 0, vatForm: 0, vatSum: 0, validate: true
      }]
    }
    this.setState({ saleDetails: sDetails })
  }

  //ugSaleDetails

  //ugDetails

  withVatChanged = () => {
    var saleObj = this.state.sale;
    var saleDet = this.state.saleDetails;
    let obj = saleDet.filter(o => o.itemId === 0);
    if (obj.length === 0) {

      saleObj.withVat = !saleObj.withVat
      if (saleObj.withVat === false) {
        saleObj.amountLeft = (saleObj.subTotal - saleObj.totalSalePayment);
        saleDet.forEach(e => {
          if (e.status === 0) {
            e.status = 2;
          }
          e.vat = 0;
          e.vatSum = 0;
        });
      } else {
        saleObj.amountLeft = (saleObj.totalSum - saleObj.totalSalePayment);
        saleDet.forEach(e => {
          if (e.status === 0) {
            e.status = 2;
          }
          var item = this.state.items.find(i => i.id === e.itemId)
          e.vat = item.vat;
          if (e.discount > 0 || e.discount2 > 0 || e.discount3 > 0 || e.discount4 > 0) {
            e.priceDiscount = calculate().calculateSale('priceMultipleDiscount')(e.price, e.discount, e.discount2, e.discount3, e.discount4);
            e.priceTvsh = calculate().calculateSale('priceTvsh')(e.priceDiscount, e.vat);
            e.totalPrice = calculate().calculateSale('totalPrice')(e.priceDiscount, e.quantity);
            // e.totalPriceTvsh= calculate().calculateSale('totalPriceTvsh')(e.totalPrice,e.vat);//1
            e.vatSum = calculate().calculateSale('vatSum')(e.totalPrice, e.vat);
            //e.vatSum = parseInt(e.quantity) * e.vatSum // e ndryshuar
            e.totalPriceTvsh = (e.totalPrice + e.vatSum);
          } else {

            e.priceTvsh = calculate().calculateSale('priceTvsh')(e.price, e.vat);
            e.totalPrice = calculate().calculateSale('totalPrice')(e.price, e.quantity);
            //  e.totalPriceTvsh= calculate().calculateSale('totalPriceTvsh')(e.totalPrice,e.vat);
            e.vatSum = calculate().calculateSale('vatSum')(e.totalPrice, e.vat);
            //e.vatSum = parseInt(e.quantity) * e.vatSum // e ndryshuar
            e.totalPriceTvsh = (e.totalPrice + e.vatSum);
          }
        });
      }
    } else {
      this.validateForm();
      this.validationAlert(helper().translate("FILL_BLANK_ITEMS"));
    }
    this.setState({ sale: saleObj });
    this.setState({ saleDetails: saleDet });
    this.totalSale();
  }

  withCashPayment = () => {

    let saleCopy = this.state.sale;
    let payBtn = this.state.paymentBtn;
    if (typeof (saleCopy.cashToPay) === 'undefined' || saleCopy.cashToPay <= 0) {
      this.validationAlert(helper().translate("PAYMENT_SUM_SHOULD_BE_BIGGER_THAN_ZERO"))
    } else {

      saleCopy.withCashPayment = !saleCopy.withCashPayment;
    }
    if (saleCopy.withCashPayment) {
      saleCopy.paymentMethod = 1;
      payBtn.savePayment = false;
      saleCopy.totalSalePayment = saleCopy.cashToPay;
      saleCopy.amountLeft = (saleCopy.totalSum - saleCopy.totalSalePayment);
    } else {
      saleCopy.paymentMethod = 3;
      saleCopy.totalSalePayment = 0;
      saleCopy.amountLeft = saleCopy.totalSum;
    }
    this.setState({ sale: saleCopy, paymentBtn: payBtn });
  }

  onFieldChange = (e, obj) => {
    var saleObj = this.state.sale;
    if (e.target.name === 'date') {
      //  var today = new Date();
      //  time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
      saleObj.date = new Date(e.target.value);
    } else if (e.target.name === 'cashToPay') {
      if (e.target.value <= saleObj.totalSum && e.target.value > 0) {

        saleObj.cashToPay = e.target.value;
        if (saleObj.withCashPayment) {
          saleObj.totalSalePayment = e.target.value;
          saleObj.amountLeft = (saleObj.totalSum - saleObj.totalSalePayment);
        }
      } else {
        this.validationAlert(helper().translate("PAYMENT_SUM_SHOULDNT_BE_BIGGER_THAN_INVOICE_TOTAL"))
      }
    } else if (e.target.name === 'reference') {
      saleObj[e.target.name] = e.target.value;
      saleObj.referenceExist = false;
      saleObj.referenceChanged = true;
    } else if (e.target.name === 'invoiceNo') {
      saleObj[e.target.name] = e.target.value;
      saleObj.invoiceExist = false;
      saleObj.invoiceChanged = true;
    }
    else {
      saleObj[e.target.name] = e.target.value;
    }

    saleObj.isChanged = true
    this.setState({ sale: saleObj })
  };

  onOtherFieldChange = (e, no) => {
    // console.log(e.target.value)
    // var saleArr = this.state.sale;
    var itemOtherDetails = this.state.itemSaleOtherDetails;
    // console.log(no)

    if ([e.target.name] == "quantity") {

      itemOtherDetails[no - 1][e.target.name] = e.target.value;

      itemOtherDetails[no - 1].totalPrice = calculate().calculateSale('totalPrice')(itemOtherDetails[no - 1].priceForUnit, e.target.value);



    } else if ([e.target.name] == "priceForUnit") {
      // saleDetailItem.totalPrice= calculate().calculateSale('totalPrice')(saleDetailItem.price,saleDetailItem.quantity);
      itemOtherDetails[no - 1][e.target.name] = e.target.value;

      itemOtherDetails[no - 1].totalPrice = calculate().calculateSale('totalPrice')(e.target.value, itemOtherDetails[no - 1].quantity);
    } else if ([e.target.name] == "totalPrice") {
      // saleDetailItem.totalPrice= calculate().calculateSale('totalPrice')(saleDetailItem.price,saleDetailItem.quantity);
      itemOtherDetails[no - 1][e.target.name] = e.target.value;

      itemOtherDetails[no - 1].priceForUnit = calculate().calculateSale('priceFromTotal')(e.target.value, itemOtherDetails[no - 1].quantity)
    } else {
      itemOtherDetails[no - 1][e.target.name] = e.target.value
    }
    this.setState({ itemOtherDetails: itemOtherDetails });
    this.otherTotalsDetails()

  };

  onSelectChange = (e, obj) => {
    if (!obj?.name) return;

    const value = e?.value ?? null;

    this.setState(prev => {
      const nextSale = {
        ...(prev.sale || {}),
        [obj.name]: value,
        isChanged: true,
      };

      return {
        sale: nextSale,
        [obj.name]: e,
      };
    }, () => {
      const { sale } = this.state;

      if (obj.name === "partnerId") {
        if (sale?.warehouseId > 0 && value > 0) {
          this.getItems(value, sale.warehouseId);
        }
      } else if (obj.name === "warehouseId") {
        this.getPartners(value);
        if (sale?.partnerId > 0 && value > 0) {
          this.getItems(sale.partnerId, value);
        }
      } else if (obj.name === "salesTypeId") {
        this.getSaleType(value);
      } else {
        this.getPartners();

        if (sale?.partnerId > 0 && sale?.warehouseId > 0) {
          this.getItems(sale.partnerId, sale.warehouseId);
        }
      }
    });
  };



  onButtonClickPay = () => {
    let saleCopy = this.state.sale;
    if (saleCopy.subTotal > 0) {
      let payBtn = this.state.paymentBtn;
      payBtn.showPayFrom = true;
      payBtn.pay = true;
      let paymentCopy = this.state.payment;
      paymentCopy[0].inputValue = (this.state.sale.totalSum);
      if (paymentCopy[1].inputValue === 0) {
        paymentCopy[1].inputValue = (this.state.sale.totalSum);

      }
      paymentCopy[5].inputValue = (this.state.sale.totalSum);

      // fillin pay selects
      let bankOptions = this.state.banksPos;
      if (bankOptions.length > 0) {
        for (let i = 2; i <= (bankOptions.length + 1); i++) {
          paymentCopy[i].bankId = bankOptions[i - 2].id;
        }
      }
      paymentCopy[4].disabled = true;
      paymentCopy[3].disabled = true;
      paymentCopy[2].disabled = true;
      this.setState({ paymentBtn: payBtn, payment: paymentCopy });
    } else {
      this.validationAlert(helper().translate("AMOUNT_LEFT_SHOULD_BE_GREATER_THAN_ZERO"))
    }
  }
  onButtonClickPayments = () => {
    let payBtn = this.state.paymentBtn;
    let saleCopy = this.state.sale;
    let paymentSalesCopy = this.state.paymentSales;
    let totalPayments = 0;
    paymentSalesCopy.forEach(e => {
      totalPayments = totalPayments + e.amountPaid;
    });
    saleCopy.totalPayments = parseFloat(totalPayments);
    payBtn.showPayments = true;
    this.setState({ paymentBtn: payBtn, sale: saleCopy })
  }
  onButtonClickOtherSD = () => {
    this.setState((prevState) => ({
      otherSalesDetails: !prevState.otherSalesDetails
    }));
  }
  hidePayments = () => {
    let sId = this.props.match.params.id;
    let payBtn = this.state.paymentBtn;
    payBtn.showPayments = false;
    this.setState({ paymentBtn: payBtn })
    this.getPaymentSales(sId);
  }

  onArrowClick = () => {
    let payBtn = this.state.paymentBtn;
    payBtn.showPayFrom = false;
    payBtn.showPayments = false;
    this.setState({ paymentBtn: payBtn });
  }

  itemChange = (e, obj, no) => {
    var salecopy = this.state.sale;
    var sDetails = this.state.saleDetails;

    if (obj.name === "projectId" || obj.name === "cityId") {
      sDetails[no - 1][obj.name] = e.value;
      this.setState({ saledetails: sDetails });
    } else if (obj.name === "vatForm") {
      sDetails[no - 1][obj.name] = e.value;
      this.setState({ saledetails: sDetails });
    }
    else {
      var saleDetailItem = sDetails.find(i => i.no === no);
      var item = this.state.items.find(i => i.id === e.value)
      saleDetailItem.barcode = item.barcode;
      saleDetailItem.itemName = item.itemName;
      saleDetailItem.itemId = item.id;
      saleDetailItem.unitId = item.unitId;
      saleDetailItem.description = item.description;
      let fullProject = this.state.projects?.find(p => p.WarehouseId === this.state.sale.warehouseId && (p.IsDefault === true ? p.IsDefault === true : true));
      saleDetailItem.projectId = fullProject?.id ? fullProject.id : 0;

      if (this.state.sale.allowLackItems === false) {
        let itemsQuantity = sDetails.filter(s => s.itemId === saleDetailItem.itemId)
        let totalQuantity = 0;
        let totalInitialQty = 0;
        itemsQuantity.forEach(s => {
          totalQuantity = parseFloat(s.quantity) + totalQuantity;
          if (s.id > 0) {
            totalInitialQty = parseFloat(s.initialUnchangedQty) + totalInitialQty;
          }
        });
        if (totalQuantity - totalInitialQty > item.quantity && item.service !== true) {
          saleDetailItem.isntAllowedQuantity = true;
        } else {
          saleDetailItem.isntAllowedQuantity = false;
        }
      }
      // this.isOnlyExport() ? item.vat = 0 : null
      // console.log(item.vat)

      saleDetailItem.vat = item.vat
      if (this.isOnlyExport()) {
        saleDetailItem.vat = 0
      }
      let vatFormId = this.state.saleVatTypes.filter(i => i.vat == saleDetailItem.vat && i.defaultVat === true)[0]?.id
      if (vatFormId) {
        saleDetailItem.vatForm = vatFormId;
      }

      if (item.discount > 0) {
        saleDetailItem.discount = item.discount;
        saleDetailItem.discount2 = 0;
        saleDetailItem.discount3 = 0;
        saleDetailItem.discount4 = 0;
        saleDetailItem.price = item.retailPrice;
        saleDetailItem.avgPrice = item.avgPrice;
        saleDetailItem.priceTvsh = (calculate().calculateSale('priceTvsh')(saleDetailItem.price, saleDetailItem.vat));
        saleDetailItem.priceDiscount = calculate().calculateSale('priceDiscountNew')(saleDetailItem.price, saleDetailItem.discount);
        saleDetailItem.priceTvsh = calculate().calculateSale('priceTvsh')(saleDetailItem.priceDiscount, saleDetailItem.vat);
        saleDetailItem.totalPrice = calculate().calculateSale('totalPrice')(saleDetailItem.priceDiscount, saleDetailItem.quantity);
        // saleDetailItem.totalPriceTvsh= calculate().calculateSale('totalPriceTvsh')(saleDetailItem.totalPrice,saleDetailItem.vat);/1
        //saleDetailItem.vatSum = calculate().calculateSale('vatSum')(saleDetailItem.totalPrice, saleDetailItem.vat);
        let vatPerUnit = parseFloat((saleDetailItem.priceDiscount * saleDetailItem.vat / 100).toFixed(2));
        saleDetailItem.vatSum = parseFloat((vatPerUnit * saleDetailItem.quantity).toFixed(2));// e ndryshuar
        saleDetailItem.totalPriceTvsh = (parseFloat(saleDetailItem.totalPrice) + saleDetailItem.vatSum);

      } else {
        saleDetailItem.discount = 0;
        saleDetailItem.discount2 = 0;
        saleDetailItem.discount3 = 0;
        saleDetailItem.discount4 = 0;
        saleDetailItem.price = item.price;
        saleDetailItem.avgPrice = item.avgPrice;
        saleDetailItem.priceTvsh = (calculate().calculateSale('priceTvsh')(saleDetailItem.price, saleDetailItem.vat));
        saleDetailItem.priceDiscount = item.price;
        saleDetailItem.totalPrice = calculate().calculateSale('totalPrice')(saleDetailItem.price, saleDetailItem.quantity);
        //saleDetailItem.vatSum = parseFloat(calculate().calculateSale('vatSum')(saleDetailItem.totalPrice, saleDetailItem.vat).toFixed(2));
        let vatPerUnit = parseFloat((saleDetailItem.priceDiscount * saleDetailItem.vat / 100).toFixed(2));
        saleDetailItem.vatSum = parseFloat((vatPerUnit * saleDetailItem.quantity).toFixed(2));// e ndryshuar
        saleDetailItem.totalPriceTvsh = (saleDetailItem.totalPrice + saleDetailItem.vatSum);
      }

      this.setState({ saleDetails: sDetails });
      this.totalSale();
    }

  }

  onFieldDetailsChange = (e, obj, no) => {
    const { name, value } = e.target;
    const { sale, saleDetails, saleVatTypes } = this.state;
    const saleDetailItem = saleDetails.find(i => i.no === no);

    const calculateVAT = (price, vat, quantity) => {
      let totalPrice = parseFloat(calculate().calculateSale('totalPrice')(price, quantity).toFixed(6));
      let vatSum = parseFloat(calculate().calculateSale('vatSum')(totalPrice, vat).toFixed(6));
      return { vatSum };
    };

    const calculatePrices = (detailItem, basePrice, name, inputedValue) => {
      detailItem.priceDiscount = parseFloat(
        calculate().calculateSale('priceMultipleDiscount')(
          basePrice,
          detailItem.discount,
          detailItem.discount2,
          detailItem.discount3,
          detailItem.discount4
        ).toFixed(6)
      );

      detailItem.totalPrice = parseFloat(
        calculate().calculateSale('totalPrice')(
          detailItem.priceDiscount,
          detailItem.quantity
        ).toFixed(6)
      );

      detailItem.priceTvsh = name !== 'priceTvsh'
        ? parseFloat(calculate().calculateSale('priceTvsh')(detailItem.priceDiscount || basePrice, detailItem.vat).toFixed(6))
        : parseFloat(inputedValue);

      const { vatSum } = calculateVAT(detailItem.priceDiscount, detailItem.vat, detailItem.quantity);
      detailItem.vatSum = vatSum;

      detailItem.totalPriceTvsh = name !== 'priceTvsh'
        ? parseFloat((detailItem.totalPrice + vatSum).toFixed(6))
        : parseFloat((inputedValue * detailItem.quantity).toFixed(6));
    };

    if (name === "price") {
      saleDetailItem.price = parseFloat(value);
      if (
        saleDetailItem.discount > 0 ||
        saleDetailItem.discount2 > 0 ||
        saleDetailItem.discount3 > 0 ||
        saleDetailItem.discount4 > 0
      ) {
        calculatePrices(saleDetailItem, value);
      } else {
        saleDetailItem.priceTvsh = parseFloat(calculate().calculateSale('priceTvsh')(value, saleDetailItem.vat).toFixed(6));
        saleDetailItem.totalPrice = parseFloat(calculate().calculateSale('totalPrice')(value, saleDetailItem.quantity).toFixed(6));
        const { vatSum } = calculateVAT(value, saleDetailItem.vat, saleDetailItem.quantity);
        saleDetailItem.vatSum = vatSum;
        saleDetailItem.priceDiscount = parseFloat(value);
        saleDetailItem.totalPriceTvsh = parseFloat((saleDetailItem.priceTvsh * saleDetailItem.quantity).toFixed(6));
      }
    } else if (name === "priceTvsh" && value > 0) {
      saleDetailItem.priceTvsh = parseFloat(value);
      if (
        saleDetailItem.discount > 0 ||
        saleDetailItem.discount2 > 0 ||
        saleDetailItem.discount3 > 0 ||
        saleDetailItem.discount4 > 0
      ) {
        saleDetailItem.price = parseFloat(
          calculate().calculateSale('priceMultipleDiscountTvsh')(
            value,
            saleDetailItem.discount,
            saleDetailItem.discount2,
            saleDetailItem.discount3,
            saleDetailItem.discount4,
            saleDetailItem.vat
          ).toFixed(6)
        );
        calculatePrices(saleDetailItem, saleDetailItem.price, name, value);
      } else {
        saleDetailItem.price = parseFloat(calculate().calculateSale('price')(value, saleDetailItem.vat).toFixed(6));
        saleDetailItem.totalPrice = parseFloat(
          calculate().calculateSale('totalPrice')(saleDetailItem.price, saleDetailItem.quantity).toFixed(6)
        );
        const { vatSum } = calculateVAT(saleDetailItem.price, saleDetailItem.vat, saleDetailItem.quantity);
        saleDetailItem.vatSum = vatSum;
        saleDetailItem.priceDiscount = parseFloat(saleDetailItem.price);
        saleDetailItem.totalPriceTvsh = parseFloat((saleDetailItem.priceTvsh * saleDetailItem.quantity).toFixed(6));
      }
    } else if (name === "totalPriceTvsh") {
      saleDetailItem.totalPriceTvsh = parseFloat(value);
      if (
        saleDetailItem.discount > 0 ||
        saleDetailItem.discount2 > 0 ||
        saleDetailItem.discount3 > 0 ||
        saleDetailItem.discount4 > 0
      ) {
        saleDetailItem.priceTvsh = parseFloat(
          calculate().calculateSale('totalPriceItemTvsh')(value, saleDetailItem.quantity).toFixed(6)
        );
        saleDetailItem.price = parseFloat(
          calculate().calculateSale('priceMultipleDiscountTvsh')(
            saleDetailItem.priceTvsh,
            saleDetailItem.discount,
            saleDetailItem.discount2,
            saleDetailItem.discount3,
            saleDetailItem.discount4,
            saleDetailItem.vat
          ).toFixed(6)
        );
        calculatePrices(saleDetailItem, saleDetailItem.price);
      } else {
        saleDetailItem.priceTvsh = parseFloat(
          calculate().calculateSale('totalPriceItemTvsh')(value, saleDetailItem.quantity).toFixed(6)
        );
        saleDetailItem.price = parseFloat(calculate().calculateSale('price')(saleDetailItem.priceTvsh, saleDetailItem.vat).toFixed(6));
        saleDetailItem.totalPrice = parseFloat(
          calculate().calculateSale('totalPrice')(saleDetailItem.price, saleDetailItem.quantity).toFixed(6)
        );
        const { vatSum } = calculateVAT(saleDetailItem.price, saleDetailItem.vat, saleDetailItem.quantity);
        saleDetailItem.vatSum = vatSum;
        saleDetailItem.priceDiscount = saleDetailItem.price;
      }
    } else if (name === "priceDiscount") {
      saleDetailItem.priceDiscount = parseFloat(value);
      if (
        saleDetailItem.discount > 0 ||
        saleDetailItem.discount2 > 0 ||
        saleDetailItem.discount3 > 0 ||
        saleDetailItem.discount4 > 0
      ) {
        saleDetailItem.priceTvsh = parseFloat(
          calculate().calculateSale('priceTvsh')(value, saleDetailItem.vat).toFixed(6)
        );
        saleDetailItem.price = parseFloat(
          calculate().calculateSale('priceMultipleDiscountTvsh')(
            saleDetailItem.priceTvsh,
            saleDetailItem.discount,
            saleDetailItem.discount2,
            saleDetailItem.discount3,
            saleDetailItem.discount4,
            saleDetailItem.vat
          ).toFixed(6)
        );
        calculatePrices(saleDetailItem, saleDetailItem.price);
      } else {
        saleDetailItem.price = parseFloat(value);
        saleDetailItem.priceTvsh = parseFloat(
          calculate().calculateSale('priceTvsh')(value, saleDetailItem.vat).toFixed(6)
        );
        saleDetailItem.totalPrice = parseFloat(
          calculate().calculateSale('totalPrice')(value, saleDetailItem.quantity).toFixed(6)
        );
        const { vatSum } = calculateVAT(value, saleDetailItem.vat, saleDetailItem.quantity);
        saleDetailItem.vatSum = vatSum;
        saleDetailItem.totalPriceTvsh = parseFloat(
          (saleDetailItem.totalPrice + vatSum).toFixed(6)
        );
      }
    } else if (name.startsWith("discount")) {
      if (value >= 0 && value <= 300) {
        saleDetailItem[name] = parseFloat(value);
        calculatePrices(saleDetailItem, saleDetailItem.price);
      } else {
        this.validationAlert("Ju lutem vendoseni zbritjen ne menyre te rregullt");
      }
    } else if (name === "vat") {
      saleDetailItem.vat = parseInt(value);
      const vatFormId = saleVatTypes.find(
        i => i.vat === saleDetailItem.vat && i.defaultVat === true
      )?.id;

      if (vatFormId) {
        saleDetailItem.vatForm = vatFormId;
      }
      if (
        saleDetailItem.discount > 0 ||
        saleDetailItem.discount2 > 0 ||
        saleDetailItem.discount3 > 0 ||
        saleDetailItem.discount4 > 0
      ) {
        calculatePrices(saleDetailItem, saleDetailItem.price);
      } else {
        saleDetailItem.priceDiscount = parseFloat(saleDetailItem.price);
        saleDetailItem.priceTvsh = parseFloat(
          calculate().calculateSale('priceTvsh')(saleDetailItem.price, saleDetailItem.vat).toFixed(6)
        );
        saleDetailItem.totalPrice = parseFloat(
          calculate().calculateSale('totalPrice')(saleDetailItem.price, saleDetailItem.quantity).toFixed(6)
        );
        const { vatSum } = calculateVAT(saleDetailItem.price, saleDetailItem.vat, saleDetailItem.quantity);
        saleDetailItem.vatSum = vatSum;
        saleDetailItem.totalPriceTvsh = parseFloat(
          (saleDetailItem.priceTvsh * saleDetailItem.quantity).toFixed(6)
        );
      }
    } else if (name === "quantity") {
      saleDetailItem.quantity = parseFloat(value);
      var item = this.state.items.find(i => i.id === saleDetailItem.itemId);
      if (this.state.sale.allowLackItems === false && value > item.quantity && !item.service) {
        this.props.addToast("Sasia e lejuar është: " + item.quantity, { appearance: 'warning', autoDismiss: true, });
        return saleDetailItem.isntAllowedQuantity = true;
      } else {
        saleDetailItem.isntAllowedQuantity = false;
      }
      if (
        saleDetailItem.discount > 0 ||
        saleDetailItem.discount2 > 0 ||
        saleDetailItem.discount3 > 0 ||
        saleDetailItem.discount4 > 0
      ) {
        calculatePrices(saleDetailItem, saleDetailItem.price);
      } else {
        saleDetailItem.priceDiscount = parseFloat(saleDetailItem.price);
        saleDetailItem.totalPrice = parseFloat(
          calculate().calculateSale('totalPrice')(saleDetailItem.price, value).toFixed(6)
        );
        const { vatSum } = calculateVAT(saleDetailItem.price, saleDetailItem.vat, value);
        saleDetailItem.vatSum = vatSum;
        saleDetailItem.totalPriceTvsh = parseFloat(
          (saleDetailItem.priceTvsh * value).toFixed(6)
        );
      }
    } else if (name === "date") {
      saleDetailItem.date = new Date(value);
    } else {
      // saleDetailItem[name] = parseFloat(value);
      saleDetailItem[name] = isNaN(value) ? value : parseFloat(value);
      if (
        saleDetailItem.discount > 0 ||
        saleDetailItem.discount2 > 0 ||
        saleDetailItem.discount3 > 0 ||
        saleDetailItem.discount4 > 0
      ) {
        calculatePrices(saleDetailItem, saleDetailItem.price);
      } else {
        saleDetailItem.priceDiscount = parseFloat(saleDetailItem.price);
        saleDetailItem.totalPrice = parseFloat(
          calculate().calculateSale('totalPrice')(saleDetailItem.price, saleDetailItem.quantity).toFixed(6)
        );
        const { vatSum } = calculateVAT(saleDetailItem.price, saleDetailItem.vat, saleDetailItem.quantity);
        saleDetailItem.vatSum = vatSum;
        saleDetailItem.totalPriceTvsh = parseFloat(
          (saleDetailItem.priceTvsh * saleDetailItem.quantity).toFixed(6)
        );
      }
    }

    this.setState({ saleDetails });
    this.totalSale();
  };

  onFieldDetailsChange1 = (e, obj, no) => {
    const { name, value } = e.target;
    const { sale, saleDetails, saleVatTypes } = this.state;
    const saleDetailItem = saleDetails.find(i => i.no === no);

    const calculateVAT = (price, vat, quantity) => {
      // const vatPerUnit = parseFloat((price * vat / 100).toFixed(2));
      // const vatSum = parseFloat((vatPerUnit * quantity).toFixed(2));
      // return { vatPerUnit, vatSum };
      let totalPrice = calculate().calculateSale('totalPrice')(price, quantity);
      let vatSum = calculate().calculateSale('vatSum')(totalPrice, vat);
      return { vatSum }
    };

    const calculatePrices = (detailItem, basePrice, name, inputedValue) => {
      detailItem.priceDiscount = calculate().calculateSale('priceMultipleDiscount')(
        basePrice,
        detailItem.discount,
        detailItem.discount2,
        detailItem.discount3,
        detailItem.discount4
      );

      detailItem.totalPrice = calculate().calculateSale('totalPrice')(
        detailItem.priceDiscount,
        detailItem.quantity
      );

      detailItem.priceTvsh = name !== 'priceTvsh' ? calculate().calculateSale('priceTvsh')(detailItem.priceDiscount || basePrice, detailItem.vat) : inputedValue;

      const { vatSum } = calculateVAT(detailItem.priceDiscount, detailItem.vat, detailItem.quantity);
      detailItem.vatSum = vatSum;
      detailItem.totalPriceTvsh = name !== 'priceTvsh' ? parseFloat(detailItem.totalPrice + vatSum).toFixed(2) : parseFloat(parseFloat(inputedValue).toFixed(2) * detailItem.quantity);
    };

    if (name === "price") {
      saleDetailItem.price = value;
      if (
        saleDetailItem.discount > 0 ||
        saleDetailItem.discount2 > 0 ||
        saleDetailItem.discount3 > 0 ||
        saleDetailItem.discount4 > 0
      ) {
        calculatePrices(saleDetailItem, value);
      } else {
        saleDetailItem.price = value;
        saleDetailItem.priceTvsh = calculate().calculateSale('priceTvsh')(value, saleDetailItem.vat);
        saleDetailItem.totalPrice = calculate().calculateSale('totalPrice')(value, saleDetailItem.quantity);
        const { vatSum } = calculateVAT(value, saleDetailItem.vat, saleDetailItem.quantity);
        saleDetailItem.vatSum = vatSum;
        saleDetailItem.priceDiscount = value;
        saleDetailItem.totalPriceTvsh = parseFloat(saleDetailItem.priceTvsh * saleDetailItem.quantity);  //parseFloat(saleDetailItem.totalPrice) + vatSum;
      }
    } else if (name === "priceTvsh" && value > 0) {
      saleDetailItem.priceTvsh = value;
      if (
        saleDetailItem.discount > 0 ||
        saleDetailItem.discount2 > 0 ||
        saleDetailItem.discount3 > 0 ||
        saleDetailItem.discount4 > 0
      ) {
        saleDetailItem.price = calculate().calculateSale('priceMultipleDiscountTvsh')(
          value,
          saleDetailItem.discount,
          saleDetailItem.discount2,
          saleDetailItem.discount3,
          saleDetailItem.discount4,
          saleDetailItem.vat
        );
        calculatePrices(saleDetailItem, saleDetailItem.price, name, value);
      } else {
        saleDetailItem.price = calculate().calculateSale('price')(value, saleDetailItem.vat);
        saleDetailItem.totalPrice = calculate().calculateSale('totalPrice')(saleDetailItem.price, saleDetailItem.quantity);
        const { vatSum } = calculateVAT(saleDetailItem.price, saleDetailItem.vat, saleDetailItem.quantity);
        saleDetailItem.vatSum = vatSum;
        saleDetailItem.priceDiscount = saleDetailItem.price;
        saleDetailItem.totalPriceTvsh = parseFloat(saleDetailItem.priceTvsh * saleDetailItem.quantity);  //parseFloat(saleDetailItem.totalPrice) + vatSum;
      }
    } else if (name === "totalPriceTvsh") {
      saleDetailItem.totalPriceTvsh = value;
      if (
        saleDetailItem.discount > 0 ||
        saleDetailItem.discount2 > 0 ||
        saleDetailItem.discount3 > 0 ||
        saleDetailItem.discount4 > 0
      ) {
        saleDetailItem.priceTvsh = calculate().calculateSale('totalPriceItemTvsh')(value, saleDetailItem.quantity);
        saleDetailItem.price = calculate().calculateSale('priceMultipleDiscountTvsh')(
          saleDetailItem.priceTvsh,
          saleDetailItem.discount,
          saleDetailItem.discount2,
          saleDetailItem.discount3,
          saleDetailItem.discount4,
          saleDetailItem.vat
        );
        calculatePrices(saleDetailItem, saleDetailItem.price);
      } else {
        saleDetailItem.priceTvsh = calculate().calculateSale('totalPriceItemTvsh')(value, saleDetailItem.quantity);
        saleDetailItem.price = calculate().calculateSale('price')(saleDetailItem.priceTvsh, saleDetailItem.vat);
        saleDetailItem.totalPrice = calculate().calculateSale('totalPrice')(saleDetailItem.price, saleDetailItem.quantity);
        const { vatSum } = calculateVAT(saleDetailItem.price, saleDetailItem.vat, saleDetailItem.quantity);
        saleDetailItem.vatSum = vatSum;
        saleDetailItem.priceDiscount = saleDetailItem.price;
      }
    } else if (name === "priceDiscount") {
      saleDetailItem.priceDiscount = value;
      if (
        saleDetailItem.discount > 0 ||
        saleDetailItem.discount2 > 0 ||
        saleDetailItem.discount3 > 0 ||
        saleDetailItem.discount4 > 0
      ) {
        saleDetailItem.priceTvsh = calculate().calculateSale('priceTvsh')(value, saleDetailItem.vat);
        saleDetailItem.price = calculate().calculateSale('priceMultipleDiscountTvsh')(
          saleDetailItem.priceTvsh,
          saleDetailItem.discount,
          saleDetailItem.discount2,
          saleDetailItem.discount3,
          saleDetailItem.discount4,
          saleDetailItem.vat
        );
        calculatePrices(saleDetailItem, saleDetailItem.price);
      } else {
        saleDetailItem.price = value;
        saleDetailItem.priceTvsh = calculate().calculateSale('priceTvsh')(value, saleDetailItem.vat);
        saleDetailItem.totalPrice = calculate().calculateSale('totalPrice')(value, saleDetailItem.quantity);
        const { vatSum } = calculateVAT(value, saleDetailItem.vat, saleDetailItem.quantity);
        saleDetailItem.vatSum = vatSum;
        saleDetailItem.totalPriceTvsh = parseFloat(saleDetailItem.totalPrice) + vatSum;
      }
    } else if (name.startsWith("discount")) {
      if (value >= 0 && value <= 300) {
        saleDetailItem[name] = value;
        calculatePrices(saleDetailItem, saleDetailItem.price);
      } else {
        this.validationAlert("Ju lutem vendoseni zbritjen ne menyre te rregullt");
      }
    } else if (name === "vat") {
      saleDetailItem.vat = parseInt(value);
      const vatFormId = saleVatTypes.find(
        i => i.vat === saleDetailItem.vat && i.defaultVat === true
      )?.id;

      if (vatFormId) {
        saleDetailItem.vatForm = vatFormId;
      }
      if (
        saleDetailItem.discount > 0 ||
        saleDetailItem.discount2 > 0 ||
        saleDetailItem.discount3 > 0 ||
        saleDetailItem.discount4 > 0
      ) {
        calculatePrices(saleDetailItem, saleDetailItem.price);
      } else {
        saleDetailItem.priceDiscount = saleDetailItem.price;
        saleDetailItem.priceTvsh = calculate().calculateSale('priceTvsh')(saleDetailItem.price, saleDetailItem.vat);
        saleDetailItem.totalPrice = calculate().calculateSale('totalPrice')(saleDetailItem.price, saleDetailItem.quantity);
        const { vatSum } = calculateVAT(saleDetailItem.price, saleDetailItem.vat, saleDetailItem.quantity);
        saleDetailItem.vatSum = vatSum;
        saleDetailItem.totalPriceTvsh = parseFloat(saleDetailItem.priceTvsh * saleDetailItem.quantity);  //parseFloat(saleDetailItem.totalPrice) + vatSum;
      }
    } else if (name === "quantity") {
      saleDetailItem.quantity = value;
      if (
        saleDetailItem.discount > 0 ||
        saleDetailItem.discount2 > 0 ||
        saleDetailItem.discount3 > 0 ||
        saleDetailItem.discount4 > 0
      ) {
        calculatePrices(saleDetailItem, saleDetailItem.price);
      } else {
        saleDetailItem.priceDiscount = saleDetailItem.price;
        saleDetailItem.totalPrice = calculate().calculateSale('totalPrice')(saleDetailItem.price, value);
        const { vatSum } = calculateVAT(saleDetailItem.price, saleDetailItem.vat, value);
        saleDetailItem.vatSum = vatSum;
        saleDetailItem.totalPriceTvsh = parseFloat(parseFloat(saleDetailItem.priceTvsh).toFixed(3) * value);  //parseFloat(saleDetailItem.totalPrice) + vatSum;
      }
    } else if (name === "date") {
      saleDetailItem.date = new Date(value);
    } else {
      saleDetailItem[name] = value;
      if (
        saleDetailItem.discount > 0 ||
        saleDetailItem.discount2 > 0 ||
        saleDetailItem.discount3 > 0 ||
        saleDetailItem.discount4 > 0
      ) {
        calculatePrices(saleDetailItem, saleDetailItem.price);
      } else {
        saleDetailItem.priceDiscount = saleDetailItem.price;
        saleDetailItem.totalPrice = calculate().calculateSale('totalPrice')(saleDetailItem.price, saleDetailItem.quantity);
        const { vatSum } = calculateVAT(saleDetailItem.price, saleDetailItem.vat, saleDetailItem.quantity);
        saleDetailItem.vatSum = vatSum;
        saleDetailItem.totalPriceTvsh = parseFloat(saleDetailItem.priceTvsh * saleDetailItem.quantity);  //parseFloat(saleDetailItem.totalPrice) + vatSum;
      }
    }

    this.setState({ saleDetails });
    this.totalSale();
  };

  paymentChange = (e, obj, no) => {
    var paymentCopy = this.state.payment;
    paymentCopy[no].bankId = e.value;
    this.setState({ payment: paymentCopy })

  }

  paymentFieldChange = (e, no) => {
    let payReturn = false;
    if (e.target.value >= 0) {
      let paymentCopy = this.state.payment;
      paymentCopy[no].inputValue = parseFloat(e.target.value);
      let bankSum = parseFloat(paymentCopy[2].inputValue) + parseFloat(paymentCopy[3].inputValue) + parseFloat(paymentCopy[4].inputValue);

      paymentCopy[5].inputValue = (parseFloat(paymentCopy[1].inputValue) + parseFloat(paymentCopy[2].inputValue) + parseFloat(paymentCopy[3].inputValue) + parseFloat(paymentCopy[4].inputValue));

      if (parseFloat(paymentCopy[1].inputValue) >= parseFloat(paymentCopy[0].inputValue)) {
        paymentCopy[2].disabled = true;
        paymentCopy[2].inputValue = 0;
        paymentCopy[3].disabled = true;
        paymentCopy[3].inputValue = 0;
        paymentCopy[4].disabled = true;
        paymentCopy[4].inputValue = 0;
        paymentCopy[5].inputValue = (parseFloat(paymentCopy[1].inputValue) + parseFloat(paymentCopy[2].inputValue) + parseFloat(paymentCopy[3].inputValue) + parseFloat(paymentCopy[4].inputValue));
        paymentCopy[7].inputValue = (parseFloat(paymentCopy[5].inputValue) - parseFloat(paymentCopy[0].inputValue));
        payReturn = true;
      } else {
        let bankOptions = this.state.banksPos;
        if (bankOptions.length === 2) {
          paymentCopy[2].disabled = false;
          paymentCopy[3].disabled = false;
        } else if (bankOptions.length === 1) {
          paymentCopy[2].disabled = false;
        } else if (bankOptions.length >= 3) {
          paymentCopy[4].disabled = false;
          paymentCopy[3].disabled = false;
          paymentCopy[2].disabled = false;
        }
      }

      if (parseFloat(paymentCopy[5].inputValue) < parseFloat(paymentCopy[0].inputValue)) {
        paymentCopy[6].inputValue = (paymentCopy[5].inputValue - parseFloat(paymentCopy[0].inputValue));
      } else {
        paymentCopy[6].inputValue = 0;
      }

      if ((paymentCopy[5].inputValue - parseFloat(paymentCopy[0].inputValue)) >= 0 && bankSum == 0) {
        paymentCopy[7].inputValue = (paymentCopy[5].inputValue - parseFloat(paymentCopy[0].inputValue));
      } else {
        if (payReturn === false) {
          paymentCopy[7].inputValue = 0;
        }
      }


      this.setState({ payment: paymentCopy });
    } else {
      // let paymentCopy = this.state.payment;
      // paymentCopy[no].inputValue = 0;
      // this.setState({payment: paymentCopy});
      this.validationAlert("Please write Positive Number");

    }
  }



  validateAllowSaleNegative = () => {

    if (this.state.sale.allowLackItems === false) {
      let itemsInStock = this.state.items;
      let saleDet = this.state.saleDetails;

      // saleDet.forEach(s => {
      //   let itemFound = itemsInStock.filter( i => i.id === s.itemId)
      //   if(parseFloat(s.quantity)  > itemFound[0].quantity){
      //     s.isntAllowedQuantity = true;
      //   }else {
      //     s.isntAllowedQuantity = false;

      //   }
      // });

      let saleDetQuantity = saleDet.filter(s => s.isntAllowedQuantity === true)

      if (saleDetQuantity.length > 0) {
        return false
      } else {
        return true
      }

    } else {
      return true
    }
  }

  validateForm = () => {
    var saleVal = this.state.sale;
    var saleDet = this.state.saleDetails;
    let obj = saleDet.filter(o => (o.itemId === 0));
    // let projectLength = saleDet.filter(o => o.projectId === 0);
    obj.forEach(e => {
      e.validate = false;
      e.editMode = false;
    });
    this.setState({ saleDetails: saleDet })
    if (saleVal.partnerId !== null && saleVal.warehouseId !== null && saleVal.salesTypeId !== null && saleVal.date !== '' && obj.length == 0) {
      return true
    } else {

      return false
    }
  }
  validatePaymentForm = () => {
    let returnValue = true;
    let paymentCopy = this.state.payment;
    let payment0 = parseFloat(paymentCopy[0].inputValue);
    let payment1 = parseFloat(paymentCopy[1].inputValue);
    let payment2 = parseFloat(paymentCopy[2].inputValue);
    let payment3 = parseFloat(paymentCopy[3].inputValue);
    let payment4 = parseFloat(paymentCopy[4].inputValue);
    let payment5 = parseFloat(paymentCopy[5].inputValue);
    let payment6 = parseFloat(paymentCopy[6].inputValue);
    let payment7 = parseFloat(paymentCopy[7].inputValue);

    let posSum = payment2 + payment3 + payment4;
    if (posSum > 0) {
      if (posSum > payment0 || (payment1 + posSum) > payment0) {
        this.validationAlert("nuk lejohet qe pagesa me banke te jete me e madhe sesa shuma per pagese");
        returnValue = false;
      }
    }
    let totalSum = payment1 + payment2 + payment3 + payment4;
    if (totalSum <= 0) {
      this.validationAlert("nuk mund te beni pagese me vlere 0");
      returnValue = false;
    }

    return returnValue;
  }


  validationAlert = (msg) => {
    this.props.addToast(msg, { appearance: 'error', autoDismiss: true, });
  }

  getSalesType = () => {
    var name = this.props.location.pathname;
    var splitstring = name.split('/');
    return splitstring[splitstring.length - 1];
  }

  newHandle = () => {
    var sale = this.state.sale;
    var id = this.props.match.params.id;
    let yesSave = true;
    var saleDet = this.state.saleDetails;
    let obj = saleDet.filter(e => (e.status === 2) || (e.status === 1));
    this.onClear()


    if (obj.length === 0 && typeof (sale.isChanged) === 'undefined') {
      this.onClear();
    } else {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui" >
              <h1>{helper().translate("ARE_YOU_SURE")}</h1>
              <p>{helper().translate("WANT_TO_SAVE_ACTUAL_CHANGES")}</p>
              <button
                onClick={() => {
                  this.saveSale(id, yesSave);
                  onClose();
                }}
              >
                {helper().translate("YES")}
              </button>
              <button onClick={() => {
                this.onClear();
                onClose();
              }} className="ms-3">{helper().translate("NO")}</button>
            </div>
          );
        }
      })
    }
  }

  backHandle = () => {
    var sale = this.state.sale;
    var id = this.props.match.params.id;
    let yesSave = false;
    let backSave = true;
    var saleDet = this.state.saleDetails;
    let obj = saleDet.filter(e => (e.status === 2) || (e.status === 1));


    if (obj.length === 0 && typeof (sale.isChanged) === 'undefined') {
      window.location.href = "#/sales"
    } else {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui" >
              <h1>{helper().translate("ARE_YOU_SURE")}</h1>
              <p>{helper().translate("WANT_TO_SAVE_ACTUAL_CHANGES")}</p>
              <button
                onClick={() => {
                  this.saveSale(id, yesSave, backSave);
                  onClose();
                }}
              >
                {helper().translate("YES")}
              </button>
              <button onClick={() => {
                onClose();
                window.location.href = "#/sales"
              }} className="ms-3">{helper().translate("NO")}</button>
            </div>
          );
        }
      })
    }


  }

  onClear = () => {
    let sale = this.state.sale;
    this.getWithWatSettings(sale.salesTypeId);
    this.getInvoiceGenerateNumberSettings();
    var saleDetails = [{
      no: 1, id: 0, itemId: 0, itemName: 'select item', date: new Date(), comment: "", barcode: 'select barcode', quantity: parseInt((sale.salesTypeId)) === 4 ? -1 : 1,
      price: 0.0, vat: 0, vatForm: 0, vatSum: 0, addButton: true, validate: true
    }];
    var itemSaleOtherDetails = [{
      no: 1, id: 0, paymentsInfo: "", quantity: 1,
      priceForUnit: 0.0, totalPrice: 0, addButton: true, validate: true, editMode: false
    }]
    this.setState({ saleDetails: saleDetails, itemSaleOtherDetails: itemSaleOtherDetails });
  }

  totalSale = (incomingSaleDetails, updateDeleteItem) => {
    if (incomingSaleDetails) {
      var sDetails = incomingSaleDetails;
    } else {

      var sDetails = this.state.saleDetails;
    }
    var mainSale = this.state.sale;
    var totalSum = 0;
    var vatSum = 0;
    var subTotal = 0
    if (this.state.sale.withVat === true) {
      sDetails.forEach(e => {
        subTotal = subTotal + Number(e.totalPrice);
        vatSum = vatSum + e.vatSum;
        totalSum = totalSum + Number(e.totalPriceTvsh);
      });
    } else {
      sDetails.forEach(e => {
        subTotal = subTotal + Number(e.totalPrice);
        totalSum = subTotal;
      });
    }

    mainSale.subTotal = subTotal;
    mainSale.vatSum = vatSum;
    mainSale.totalSum = totalSum;
    mainSale.cashToPay = parseFloat(totalSum);
    if (mainSale.withVat) {
      mainSale.amountLeft = (mainSale.totalSum - mainSale.totalSalePayment);
    } else {
      mainSale.amountLeft = (mainSale.subTotal - mainSale.totalSalePayment);
    }
    this.setState({ sale: mainSale })
    if (updateDeleteItem) {
      this.deleteIemUpdate(mainSale);
    }
  }

  otherTotalsDetails = (incoming) => {

    if (incoming) {
      var sDetails = incoming;
    } else {
      var sDetails = this.state.itemSaleOtherDetails
    }


    var totalSum = 0;
    sDetails.forEach(e => {
      totalSum = totalSum + parseFloat(e.totalPrice);
    });
    this.setState({ totalOtherDetails: totalSum })
  }

  // getDateTime = () => {

  // var today = new Date();
  // var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
  // var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
  // var dateTime = date+' '+time;
  // return dateTime
  // }

  deleteIemUpdate = () => {
    this.state.sale.changedBy = globals().getLogedInUser().data.username;
    this.state.sale.id = this.props.match.params.id;
    apiService().execute('updateSale', this.state.sale, 'post')
      .then((response) => {
        if (response.success) {
        }
        else {
          this.props.addToast('Update Error', { appearance: 'error', autoDismiss: true, });
        }
      });
  }

  updateSale = (id, yesSave, backSave) => {
    if (this.validateForm()) {
      this.state.sale.changedBy = globals().getLogedInUser().data.username;
      if (id > 0) {
        this.state.sale.id = id
      } else {
        this.state.sale.id = this.props.match.params.id;
      }
      var saleDet = this.state.saleDetails;
      apiService().execute('updateSale', this.state.sale, 'post')
        .then((response) => {
          if (response.success) {
            var updateSaleDetails = [];
            let obj = saleDet.filter(e => (e.status === 2) || (e.status === 1));
            obj.forEach(e => {
              e.saleId = this.state.sale.id
              var contextObj = {
                entity: e,
                status: e.status,
                type: 'salesDetails'
              }
              updateSaleDetails.push(contextObj);
            });
            apiService().saveChanges(updateSaleDetails).then((response) => {
              if (response.success) {
                saleDet.forEach(e => {
                  e.status = 0
                });
              };
              if (backSave === true) {
                window.location.href = "#/sales"
              } else {

                if (yesSave === true) {
                  this.onClear();
                } else {
                  this.props.history.push('/edit_sale/' + this.props.match.params.id);
                }
              }
            })
            //update payments and paymentsales
            // if(this.state.sale.paymentMethod == 1){
            //   let updatePaymentSale = { debit: this.state.sale.totalSum , amountPaid: this.state.sale.totalSum , changedBy: globals().getLogedInUser().data.name + globals().getLogedInUser().data.surname };
            //   apiService().query("getPaymentSales", "saleId="+this.props.match.params.id).then((response) => {
            //     if(response.success){
            //       if(response.data.length != 0){
            //         let paymentId = response.data[0].paymentId;
            //         updatePaymentSale.paymentId = paymentId;
            //         updatePaymentSale.saleId = this.props.match.params.id;
            //         apiService().execute('updatePaymentSales', updatePaymentSale , 'post').then((response) => {
            //           if(response.success){
            //             console.log("me sukses update i paymentSales")
            //           }else{
            //             his.props.addToast('ju lutem rregulloni pagesen ', { appearance: 'error', autoDismiss: true, });
            //           }
            //         })
            //       }
            //     }})
            // }
            // this.props.addToast('Update Success', { appearance: 'success', autoDismiss: true, });
            this.props.addToast('Update Success', { appearance: 'success', autoDismiss: true, });
          }
          else {
            this.props.addToast('Update Error', { appearance: 'error', autoDismiss: true, });
          }
        });
    } else {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui" >
              <h1>Gabim</h1>
              <p>Plotesoni fushat e kerkuara</p>
              <button onClick={onClose}>Ne Rregull</button>
            </div>
          );
        }

      })
      // this.setState({validate: true})
    }
  }

  updateOtherDetails = () => {
    var saleOtherDet = this.state.itemSaleOtherDetails;
    var updateOtherDetails = [];
    let obj = saleOtherDet.filter(e => (e.status === 2) || (e.status === 1));
    obj.forEach(e => {
      var contextObj = {
        entity: e,
        status: e.status,
        type: 'otherSalesDetails'
      }
      updateOtherDetails.push(contextObj);
    });
    apiService().saveChanges(updateOtherDetails).then((response) => {
      if (response.success) {
        saleOtherDet.forEach(e => {
          e.status = 0
        });
      };
    })
  }

  saveOnlyOnce = () => {
    var element = document.getElementById("saveOnce");
    element.classList.toggle("disabled");
  }


  saveSale = (id, yesSave, backSave) => {

    if (this.validateAllowSaleNegative() || this.state.sale.salesTypeId === 4) {

      if (id > 0) {
        var saleId = id;
      } else {

        var saleId = this.props.match.params.id;
      }
      var sDetails = this.state.saleDetails;


      if (saleId === '0') {
        this.saveOnlyOnce();
        let invoiceNo = this.state.invoiceIdFormat === false ? this.state.sale.invoiceNo : '';
        let params = `reference=${this.state.sale.reference}&invoiceNo=${invoiceNo}`;
        apiService()
          .query(
            "searchSaleReference",
            params
          )
          .then((response) => {
            if ((response.success && response.data[0].reference === 0 && response.data[0].invoice === 0)) {
              if (this.validateForm()) {
                this.state.sale.createdBy = globals().getLogedInUser().data.username;
                this.state.sale.invoiceFormatString = this.state.salesType.find(st => st.id == this.state.sale.salesTypeId).tokenName ? this.state.salesType.find(st => st.id == this.state.sale.salesTypeId).tokenName : "LOCAL_SALE";
                if (this.state.paymentBtn.savePayment === true) {
                  if (this.state.payment[1].inputValue > 0) {
                    this.state.sale.paymentMethod = 1
                  } else if ((this.state.payment[2].inputValue + this.state.payment[3].inputValue + this.state.payment[4].inputValue) > 0) {
                    this.state.sale.paymentMethod = 2
                  }
                }

                apiService().execute('insertSale', this.state.sale, 'post')
                  .then((response) => {
                    if (response.success) {

                      // insert payment and paymentSales
                      if (this.state.paymentBtn.savePayment == true || this.state.sale.paymentMethod == 1) {
                        if (this.state.paymentBtn.savePayment == true) {
                          var pay = this.state.payment.filter(p => p.objective == "pay");
                          // arka = totali i pageses kur arka > totali i pageses
                          if (this.state.payment[1].inputValue >= this.state.payment[0].inputValue) {
                            pay[0].inputValue = this.state.payment[0].inputValue;
                          }
                        }
                        if (this.state.sale.paymentMethod == 1) {
                          var pay = this.state.payment.filter(p => p.name == "cash");
                        }
                        let toBePaid = pay.filter(p => p.inputValue > 0);
                        let saleCopy = this.state.sale;
                        let saleId = response.data[0].id;
                        if (toBePaid.length > 0) {
                          toBePaid.forEach(e => {
                            let paidObj = new Object;
                            paidObj.debit = e.inputValue;
                            paidObj.date = saleCopy.date;
                            paidObj.reference = '';
                            paidObj.partnerId = saleCopy.partnerId;
                            paidObj.warehouseId = saleCopy.warehouseId;
                            paidObj.credit = 0;
                            paidObj.saldo = e.inputValue;
                            paidObj.userId = globals().getLogedInUser().data.id;
                            paidObj.description = '';
                            paidObj.paymentType = 3;
                            paidObj.projectId = 0; // me e vendos
                            paidObj.createdBy = globals().getLogedInUser().data.username;
                            if (e.name === "cash") {
                              paidObj.cashBoxId = this.state.currentUserCashBoxId;
                              paidObj.bankId = 0;
                              paidObj.accountId = this.state.defaultAccount.defaultCashAccount;

                            } else {
                              paidObj.cashBoxId = 0;
                              paidObj.bankId = e.bankId;
                              paidObj.accountId = this.state.defaultAccount.defaultBankAccount;
                            }

                            // console.log(paidObj);
                            apiService().execute('insertPaymentFromSale', paidObj, 'post')
                              .then((response) => {
                                if (response.success) {
                                  let paymentId = response.data[0].id;
                                  let insertPaymentSales = { paymentId: paymentId, saleId: saleId, amountPaid: paidObj.debit, createdBy: paidObj.createdBy };
                                  apiService().execute('insertPaymentSales', insertPaymentSales, 'post')
                                    .then((response) => {
                                      if (response.success) {
                                        console.log("insertimi me sukses");
                                      }
                                    })
                                }
                              })
                          });
                        }
                      }

                      { this.state.saveSaleOtherDetails === true && this.itemOtherSaleDetails(response.data[0].id) };
                      sDetails.forEach(e => {
                        e.saleId = response.data[0].id;
                        e.status = 0;
                        apiService().execute('insertSaleDetails', e, 'post').then((response) => {
                          if (response.success) {

                            if (backSave === true) {

                              window.location.href = "#/sales"
                            } else {
                              if (yesSave === true) {
                                this.onClear();
                              } else {
                                this.props.history.push('/edit_sale/' + e.saleId);
                              }
                            }


                          }
                        })
                      });
                      // this.getSaleDetails(response.data[0].id);
                      this.props.addToast('Insert Success', { appearance: 'success', autoDismiss: true, });
                      //this.props.history.push('/sales')
                      this.setState({ validate: false });
                    }
                    else {
                      this.saveOnlyOnce();
                      this.props.addToast('Ka ndodhur nje gabim', { appearance: 'error', autoDismiss: true, });
                    }
                  });
              } else {
                this.saveOnlyOnce();
                confirmAlert({
                  customUI: ({ onClose }) => {
                    return (
                      <div className="custom-ui" >
                        <h1>Gabim</h1>
                        <p>Plotesoni fushat e kerkuara</p>
                        <button onClick={onClose}>Ne Rregull</button>
                      </div>
                    );
                  }

                })
                this.setState({ validate: true })
              }
            } else if (response.data[0].reference > 0) {
              this.props.addToast(helper().translate("REFERENCE_NUMBER_EXISTS"), { appearance: 'error', autoDismiss: true, });
              let saleArr = this.state.sale;
              saleArr.referenceExist = true;
              this.setState({ sale: saleArr })
              this.saveOnlyOnce();
            } else if (response.data[0].invoice > 0) {
              this.props.addToast(helper().translate("INVOICE_NUMBER_EXISTS"), { appearance: 'error', autoDismiss: true, });
              let saleArr = this.state.sale;
              saleArr.invoiceExist = true;
              this.setState({ sale: saleArr })
              this.saveOnlyOnce();
            }
          })

      } else {
        //Update
        let invoiceNo = this.state.invoiceIdFormat === false ? this.state.sale.invoiceNo : '';
        let params = `reference=${this.state.sale.reference}&invoiceNo=${invoiceNo}`;
        apiService()
          .query(
            "searchSaleReference",
            params
          )
          .then((response) => {
            if (this.state.sale.referenceChanged === true || this.state.sale.invoiceChanged === true) {
              if ((response.success && response.data[0].reference === 0 && response.data[0].invoice === 0)) {
                this.updateSale(id, yesSave, backSave);
                { this.state.saveSaleOtherDetails === true && this.updateOtherDetails() }

              } else if (response.data[0].reference > 0) {
                this.props.addToast(helper().translate("REFERENCE_NUMBER_EXISTS"), { appearance: 'error', autoDismiss: true, });
                let saleArr = this.state.sale;
                saleArr.referenceExist = true;
                this.setState({ sale: saleArr })
              } else if (response.data[0].invoice > 0) {
                this.props.addToast(helper().translate("INVOICE_NUMBER_EXISTS"), { appearance: 'error', autoDismiss: true, });
                let saleArr = this.state.sale;
                saleArr.invoiceExist = true;
                this.setState({ sale: saleArr })
              }
            } else {
              this.updateSale(id, yesSave, backSave);
              { this.state.saveSaleOtherDetails === true && this.updateOtherDetails() }
            }

          })

      }
    } else {
      this.props.addToast(helper().translate('NEGATIVE_SALE_ISNT_ALLOWED'), { appearance: 'error', autoDismiss: true, });
    }
  }

  saveOtherDetails = () => {
    this.setState({ saveSaleOtherDetails: true })
    this.onButtonClickOtherSD()
    this.props.addToast(helper().translate("SAVE_SALE_TO_SAVE_OTHERDETAILS"), { appearance: 'info', autoDismiss: true, });
  }
  itemOtherSaleDetails = (incomingSaleId) => {

    let otherSdetails = this.state.itemSaleOtherDetails;

    otherSdetails.forEach(e => {
      e.saleId = incomingSaleId;
      e.status = 0;
      apiService().execute('otherSalesDetailsInsert', e, 'post').then((response) => {
      })
    });

    // setDisableSaveBtn(true);
    // let length = items.length -1;
    // let insertPayment = [...items][length];
    // if(insertPayment.insertItem === true) {
    //   apiService().execute('insertPaymentFromSale', insertPayment , 'post')
    //   .then((response) => {
    //     if(response.success){
    //       let paymentId = response.data[0].id;
    //       let insertPaymentSales = {paymentId: paymentId , saleId: props.saleId , amountPaid: insertPayment.debit , createdBy: insertPayment.createdBy };
    //       apiService().execute('insertPaymentSales', insertPaymentSales , 'post')
    //       .then((response) => {
    //         if(response.success){
    //           getPaymentSales(props.saleId , true);
    //           setDisableSaveBtn(false);

    //         }else{
    //           setDisableSaveBtn(false);
    //         }
    //       })
    //     }
    //   })
    // }
  }
  savePayment = () => {
    let payBtn = this.state.paymentBtn;
    let saleObj = this.state.sale;
    let paymentCopy = this.state.payment;
    let paymentSumCheck = parseFloat(paymentCopy[1].inputValue) + parseFloat(paymentCopy[2].inputValue) + parseFloat(paymentCopy[3].inputValue) + parseFloat(paymentCopy[4].inputValue);
    if (this.validatePaymentForm()) {
      if (paymentSumCheck > 0) {
        payBtn.savePayment = true;
        saleObj.totalSalePayment = (paymentCopy[5].inputValue);
        saleObj.amountLeft = (paymentCopy[0].inputValue - saleObj.totalSalePayment);
        this.props.addToast("Saved Successfully", { appearance: 'success', autoDismiss: true, });
        this.setState({ paymentBtn: payBtn, sale: saleObj });
        this.onArrowClick();
      }
    }

  }
  addItemsForm = () => {
    var sDetails = this.state.saleDetails;
    var saleId = this.props.match.params.id;
    if (saleId > 0) {

      var newItem = { no: Math.max(...sDetails.map(o => o.no), 0) + 1, date: new Date(), comment: "", id: 0, itemId: 0, itemName: 'zgjidheni artikullin', barcode: 'zgjidheni barkodin', quantity: parseInt(this.state?.sale?.salesTypeId) === 4 ? -1 : 1, saleId: parseInt(saleId), price: 0.0, avgPrice: 0, vat: 0, vatForm: 0, vatSum: 0, projectId: 0, addButton: true, validate: true, totalPrice: 0, totalPriceTvsh: 0, status: 1 };
    } else {

      var newItem = {
        no: Math.max(...sDetails.map(o => o.no), 0) + 1, date: new Date(), comment: "", id: 0, itemId: 0, itemName: 'zgjidheni artikullin', barcode: 'zgjidheni barkodin', quantity: parseInt((this.props.location.search).substring(1, this.props.location.search.length)) === 4 ? -1 : 1,
        price: 0.0, avgPrice: 0, vat: 0, vatForm: 0, vatSum: 0, projectId: 0, addButton: true, validate: true, totalPrice: 0, totalPriceTvsh: 0
      };
    }
    sDetails.push(newItem);

    for (var i = 0; i < sDetails.length; i++) {
      sDetails[i].addButton = false;
      sDetails[i].editMode = false;
      if (i === (sDetails.length - 1)) {
        sDetails[i].addButton = true;
        sDetails[i].editMode = true;
      }
    }

    this.setState({ saleDetails: sDetails });
  }

  addRowOtherDetails = () => {
    var itemSaleOtherDetails = this.state.itemSaleOtherDetails;
    var saleId = this.props.match.params.id;
    if (saleId > 0) {


      var newItem = { no: Math.max(...itemSaleOtherDetails.map(o => o.no), 0) + 1, id: 0, saleId: parseInt(saleId), paymentsInfo: "", quantity: 1, priceForUnit: 0.0, totalPrice: 0, addButton: true, validate: true, editMode: true, status: 1 }
    } else {

      var newItem = { no: Math.max(...itemSaleOtherDetails.map(o => o.no), 0) + 1, id: 0, paymentsInfo: "", quantity: 1, priceForUnit: 0.0, totalPrice: 0, addButton: true, validate: true, editMode: true }
    }
    itemSaleOtherDetails.push(newItem);

    for (var i = 0; i < itemSaleOtherDetails.length; i++) {
      itemSaleOtherDetails[i].addButton = false;
      itemSaleOtherDetails[i].editMode = false;
      if (i === (itemSaleOtherDetails.length - 1)) {
        itemSaleOtherDetails[i].addButton = true;
        itemSaleOtherDetails[i].editMode = true;
      }
    }

    this.setState({ itemSaleOtherDetails: itemSaleOtherDetails });
  };


  deleteitem = (rowId) => {
    var sDetails = this.state.saleDetails;
    var getRow = this.state.saleDetails.filter((row) => row.no == rowId);
    if (getRow[0].id > 0) {
      apiService().query('deleteSaleDetails', "id=" + getRow[0].id).then((response) => {
        if (response.success) {
          var sDetails = this.state.saleDetails.filter((row) => row.no !== rowId);
          if (sDetails.length === 0) {
            var newItem = { no: Math.max(...sDetails.map(o => o.no), 0) + 1, date: new Date(), comment: "", id: 0, itemId: 0, itemName: 'zgjidheni artikullin', barcode: 'zgjidheni barkodin', quantity: 1, price: 0.0, avgPrice: 0, saleId: parseInt(this.props.match.params.id), vat: 0, vatForm: 0, vatSum: 0, addButton: true, validate: true, status: 1 };
            sDetails.push(newItem);
          }
          for (var i = 0; i < sDetails.length; i++) {
            if (i === (sDetails.length - 1)) {
              sDetails[i].addButton = true;
            }
          }
          var num = 1;
          sDetails.forEach(i => { i.no = num; num++ });
          // console.log("sdetails" , sDetails);
          var updateSaleDetails = [];
          var count = 1;
          var arr = this.state.saleDetails.filter((i) => i.id !== getRow[0].id);
          arr.forEach(i => { i.no = count; count++ });
          // console.log("Arr" , arr);
          arr.forEach(e => {
            var contextObj = {
              entity: e,
              status: 2,
              type: 'salesDetails'
            }
            updateSaleDetails.push(contextObj);
          });
          //  console.log("items to update" ,updateSaleDetails)
          apiService().saveChanges(updateSaleDetails).then((response) => {
            if (response.success) {
              console.log("me sukses")
            }
          })

          this.totalSale(sDetails, true);
          this.setState({ saleDetails: sDetails });
          this.getItems(this.state.sale.partnerId, this.state.sale.warehouseId)
        } else {
          console.log('Error:' + response.errorMessage);
        }
      });
    } else {
      var sDetails = this.state.saleDetails.filter((row) => row.no !== rowId);
      for (var i = 0; i < sDetails.length; i++) {
        if (i === (sDetails.length - 1)) {
          sDetails[i].addButton = true;
        }
      }
      var count = 1;
      sDetails.forEach(i => { i.no = count; count++ });
      if (sDetails.length === 0) {
        var newItem = {
          no: Math.max(...sDetails.map(o => o.no), 0) + 1, id: 0, itemId: 0, itemName: 'select item', barcode: 'select barcode', quantity: 1,
          price: 0.0, vat: 0, vatForm: 0, vatSum: 0, addButton: true
        };
        sDetails.push(newItem);
      }
      this.totalSale(sDetails);
    }



    this.setState({ saleDetails: sDetails });
  }
  deleteOtherItem = (rowId) => {
    var sDetails = this.state.itemSaleOtherDetails;
    var getRow = this.state.itemSaleOtherDetails.filter((row) => row.no == rowId);
    if (getRow[0].id > 0) {
      apiService().query('deleteOtherDetails', "id=" + getRow[0].id).then((response) => {
        if (response.success) {
          var sDetails = this.state.itemSaleOtherDetails.filter((row) => row.no !== rowId);
          if (sDetails.length === 0) {
            var newItem = [{
              no: Math.max(...sDetails.map(o => o.no), 0) + 1, id: 0, saleId: parseInt(this.props.match.params.id), paymentsInfo: "", quantity: 1,
              priceForUnit: 0.0, totalPrice: 0, addButton: true, validate: true, status: 1
            }]
            sDetails.push(newItem);
          }
          for (var i = 0; i < sDetails.length; i++) {
            if (i === (sDetails.length - 1)) {
              sDetails[i].addButton = true;
            }
          }
          var num = 1;
          sDetails.forEach(i => { i.no = num; num++ });
          // console.log("sdetails" , sDetails);
          var updateOtherDetails = [];
          var count = 1;
          var arr = this.state.itemSaleOtherDetails.filter((i) => i.id !== getRow[0].id);
          arr.forEach(i => { i.no = count; count++ });
          // console.log("Arr" , arr);
          arr.forEach(e => {
            var contextObj = {
              entity: e,
              status: 2,
              type: 'otherSalesDetails'
            }
            updateOtherDetails.push(contextObj);
          });
          //  console.log("items to update" ,updateOtherDetails)
          apiService().saveChanges(updateOtherDetails).then((response) => {
            if (response.success) {
            }
          })

          this.otherTotalsDetails(sDetails)
          this.setState({ itemSaleOtherDetails: sDetails });
          this.getOtherDetails(this.state.sale.id)
        } else {
          console.log('Error:' + response.errorMessage);
        }
      });
    } else {
      var sDetails = this.state.itemSaleOtherDetails.filter((row) => row.no !== rowId);
      for (var i = 0; i < sDetails.length; i++) {
        if (i === (sDetails.length - 1)) {
          sDetails[i].addButton = true;
        }
      }
      var count = 1;
      sDetails.forEach(i => { i.no = count; count++ });
      if (sDetails.length === 0) {
        var newItem = [{
          no: Math.max(...sDetails.map(o => o.no), 0) + 1, id: 0, paymentsInfo: "", quantity: 1,
          priceForUnit: 0.0, totalPrice: 0, addButton: true
        }]
        sDetails.push(newItem);
      }
      this.otherTotalsDetails(sDetails)
    }



    this.setState({ itemSaleOtherDetails: sDetails });
  }

  addRowEnter = (event) => {
    if (event.key === 'Enter') {
      this.addItemsForm();
    }
  }


  alertnOnDelete = (no, id) => {

    if (id > 0) {

      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui" >
              <h1>A jeni te sigurt?</h1>
              <p>Dëshironi të fshini këtë artikull?</p>
              <button
                onClick={() => {
                  this.deleteitem(no);
                  onClose();
                }}
              >
                Po , Fshije!
              </button>
              <button onClick={onClose}>Jo</button>
            </div>
          );
        }

      })
    } else {
      this.deleteitem(no);
    }

  };
  alertOnOtherDelete = (no, id) => {

    if (id > 0) {

      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui" >
              <h1>A jeni te sigurt?</h1>
              <p>Dëshironi të fshini këtë detaj?</p>
              <button
                onClick={() => {
                  this.deleteOtherItem(no);
                  onClose();
                }}
              >
                Po , Fshije!
              </button>
              <button onClick={onClose}>Jo</button>
            </div>
          );
        }

      })
    } else {
      this.deleteOtherItem(no);
    }

  };

  rowClick = (no) => {
    if (this.state.sale.partnerId > 0 && this.state.sale.warehouseId > 0 && this.state.warehouse?.find(ware => ware.id == this.state.sale.warehouseId)) {

      var saleDetails = this.state.saleDetails;

      saleDetails.forEach(i => i.editMode = false);

      saleDetails[no - 1].editMode = !saleDetails[no - 1].editMode;

      if (saleDetails[no - 1].id > 0) {
        saleDetails[no - 1].status = 2;
      } else {
        saleDetails[no - 1].status = 1;
      }
      this.setState(saleDetails);
    } else {
      this.props.addToast(helper().translate("PLEASE_CHOOSE_PARTNER_AND_WAREHOUSE"), { appearance: 'error', autoDismiss: true, });
    }
  }

  rowClickOtherDetails = (no) => {

    var otherSalesDetails = this.state.itemSaleOtherDetails;

    otherSalesDetails.forEach(i => i.editMode = false);

    otherSalesDetails[no - 1].editMode = !otherSalesDetails[no - 1].editMode;

    if (otherSalesDetails[no - 1].id > 0) {
      otherSalesDetails[no - 1].status = 2;
    } else {
      otherSalesDetails[no - 1].status = 1;
    }
    this.setState({ itemSaleOtherDetails: otherSalesDetails })

  }
  partnerBtn = () => {
    return (
      this.setState({ partnerShow: true })
    )
  }

  print = (item, invoiceForm) => {
    if (this.state.totalOtherDetails) {
      window.open(`#/print-with-other-details/${item.id}`, 'popUpWindow', 'height=1300,width="100%",left=100,top=100,right=100,bottom=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes')
    } else {
      window.open(`#/print${invoiceForm}/${item.id}`, 'popUpWindow', 'height=1300,width="100%",left=100,top=100,right=100,bottom=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes')

    }

  }

  digitalPrint = (item, invoiceForm) => {
    window.open(`#/print${invoiceForm}/${item.id}/ds`, 'popUpWindow', 'height=1300,width="100%",left=100,top=100,right=100,bottom=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes')
  }

  sendToEmail5 = () => {
    this.props.addToast("Së shpejti", { appearance: 'info', autoDismiss: true, });
  }

  generatePDFSafely = (saleId) => {
    return new Promise((resolve) => {
      const container = document.createElement('div');
      document.body.appendChild(container);

      const element = <Invoice4 saleId={saleId} />;

      import('react-dom').then((ReactDOM) => {
        ReactDOM.render(element, container);

        // Jep kohë për useEffect të ngarkohet (jo ideal, por zgjidhje funksionale)
        setTimeout(async () => {
          const blob = await pdf(element).toBlob();
          resolve(blob);
          ReactDOM.unmountComponentAtNode(container);
          document.body.removeChild(container);
        }, 1000); // 1 sekondë pritje
      });
    });
  };

  completeSaleWithDetails = async (sale) => {
    return new Promise((resolve, reject) => {
      apiService()
        .query('getWarehouseWithBranchDetails', 'warehouseId=' + sale.warehouseId)
        .then((response) => {
          if (response.success) {
            let warData = response.data[0];
            sale.warehouseAddress = warData.address;
            sale.unitNo = warData.unitNo;
            sale.branchPhone = warData.phone;
            sale.email = warData.email;
            sale.totalSum = (parseFloat(sale.totalSum) - parseFloat(sale.vatSum));
            sale.totalTvsh = (parseFloat(sale.totalSum) + parseFloat(sale.vatSum));
            sale.partner = this.state.partners.find(p => p.id == this.state.sale.partnerId);
            sale.isExport = this.isitExport();

            this.getSaleDetailsForAtach(sale).then((result) => {
              sale.salesDetails = result.salesDetails;
              sale.vatGroup = result.vatGroup;
              sale.totalWithoutDiscount = result.totalWithoutDiscount;
              resolve(sale); // Kthen objektin e plotë sale
            });

            sale.units = this.state.units;
            sale.settings = this.state.settings;
          } else {
            console.log('Error:' + response.errorMessage);
            reject(response.errorMessage);
          }
        });
    });
  };

  getSaleDetailsForAtach = (sale) => {
    return new Promise((resolve, reject) => {
      apiService()
        .query("getSaleDetails", "saleId=" + sale.id)
        .then((response) => {
          var data = response.data;
          if (response.success) {
            var totalWithoutDiscount = 0;
            for (var i = 0; i < data.length; i++) {
              // parseFloat(data[i].vat) > 0 && setIsVat(true)
              // parseFloat(data[i].discount) > 0 && setIsDiscount(true)
              // parseFloat(data[i].discount2) > 0 && setIsDiscount2(true)
              // parseFloat(data[i].discount3) > 0 && setIsDiscount3(true)
              // parseFloat(data[i].discount4) > 0 && setIsDiscount4(true)
              var addedTotalWithoutDiscount = parseFloat(data[i].quantity) * parseFloat(data[i].price);
              totalWithoutDiscount = totalWithoutDiscount + addedTotalWithoutDiscount;
              if (data[i].discount > 0 || data[i].discount2 > 0 || data[i].discount3 > 0 || data[i].discount4 > 0) {
                data[i].priceDiscount = calculate().calculateSale('priceMultipleDiscount')(data[i].price, data[i].discount, data[i].discount2, data[i].discount3, data[i].discount4);
                data[i].priceTvsh = calculate().calculateSale("priceTvsh")(
                  data[i].priceDiscount,
                  data[i].vat
                );
                data[i].totalPrice = calculate().calculateSale("totalPrice")(
                  data[i].priceDiscount,
                  data[i].quantity
                );
                data[i].totalPriceTvsh = calculate().calculateSale(
                  "totalPriceTvsh"
                )(data[i].totalPrice, data[i].vat);
                // data[i].totalPriceItemTvsh= calculate().calculateSale('totalPriceItemTvsh')(data[i].totalPriceTvsh , data[i].quantity);
              } else {
                data[i].priceTvsh = calculate().calculateSale("priceTvsh")(
                  data[i].price,
                  data[i].vat
                );
                data[i].totalPrice = calculate().calculateSale("totalPrice")(
                  data[i].price,
                  data[i].quantity
                );
                data[i].totalPriceTvsh = calculate().calculateSale(
                  "totalPriceTvsh"
                )(data[i].totalPrice, data[i].vat);
                // data[i].totalPriceItemTvsh= calculate().calculateSale('totalPriceItemTvsh')(data[i].totalPriceTvsh , data[i].quantity);
              }
            }

            const vatGroup = this.grupByVat(data);

            resolve({
              salesDetails: data,
              vatGroup: vatGroup,
              totalWithoutDiscount: totalWithoutDiscount
            });
            //setSaleDetails(data);
            // setCalTotalWithoutDiscount(totalWithoutDiscount);
            // setLoader(false);

            resolve(data); // kthejmë salesDetails për në sale.salesDetails
          } else {
            console.log("ka gabim sd: ", response);
            reject(response.errorMessage);
          }
        });
    });
  };

  grupByVat = (items) => {
    let group = items.reduce((r, a) => {
      r[a.vat] = [...(r[a.vat] || []), a];
      return r;
    }, {});
    return this.vatGroupFunc(group);
  };

  vatGroupFunc = (group) => {
    let arr = [];
    Object.entries(group).forEach(([key, value]) => {
      arr.push({ key: key, value: this.calculateVat(value) });
    });
    return arr;
  };

  calculateVat = (items) => {
    return items?.reduce(
      (accumulator, current) => parseFloat(accumulator) + current.vatSum,
      0
    );
  };

  replacePlaceholders(template, replacements) {
    return template.replace(/@(\w+)/g, (_, key) => {
      return replacements[key] ?? '';
    });
  }

  convertNewlinesToHtml(text) {
    return text.replace(/\n/g, '<br>');
  }

  sendToEmail = async () => {
    this.setState({ isSending: true });

    try {
      const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      };

      let partner = this.state.partnersFull.find(partner => partner.id == (this.state.sale.partnerId != null ? this.state.sale.partnerId : ''));
      let sale = this.state.sale;
      let settings = this.state.settings;

      if (!isValidEmail(partner.email)) {
        this.props.addToast(helper().translate("EMAIL_INVALID_PARTNER"), { appearance: 'error', autoDismiss: true, });
        return;
      }

      if (!isValidEmail(settings.email)) {
        this.props.addToast(helper().translate("EMAIL_INVALID_COMPANY"), { appearance: 'error', autoDismiss: true, });
        return;
      }

      if (!settings.digitalStamp) {
        this.props.addToast(helper().translate("EMAIL_NO_DIGITAL_SEAL"), { appearance: 'error', autoDismiss: true, });
        return;
      }

      const completedSale = await this.completeSaleWithDetails(sale);

      // 1️⃣ Gjenerojmë PDF si Blob
      const invoiceMap = {
        1: InvoiceDocument1,
        2: InvoiceDocument2,
        3: InvoiceDocument3,
        4: InvoiceDocument4,
        5: InvoiceDocument5,
      };

      const InvoiceComponent = invoiceMap[settings.invoiceForm] || InvoiceDocument1;

      const pdfBlob = await pdf(<InvoiceComponent saleObj={completedSale} />).toBlob();

      // 2️⃣ Konvertojmë Blob në Base64 string
      const pdfBase64 = await this.blobToBase64(pdfBlob);

      const replacements = {
        partner: partner?.companyName,
        company: settings?.companyName,
        companyEmail: settings?.email,
        invoiceNo: sale?.invoiceNo,
        total: sale?.totalSum,
        date: helper().formatDate(sale?.date, 'dd.MM.yyyy'),
        // shto sa të duash
      };

      const footerNote = `
        <br><br>
        <hr style="border: none; border-top: 1px solid #ccc; margin: 10px 0;">
        <div style="font-size: 0.85rem; color: #555; font-style: italic; line-height: 1.6; display: flex; align-items: center; gap: 10px;">
          <img src="https://t3next.com/unilogin/static/media/t3logo.b528c8d8962f52f8b0b1.png" alt="T3 Next" width="60" style="margin: 3px 10px 3px 3px;" />
          <div style="border-left: 1px solid #ccc; padding-left: 10px;">
            Ky email është dërguar përmes sistemit <strong style="color: #007bff;">T3 Next</strong>.<br>
            <span style="color: #999;"> 
              <a href="https://t3next.com" target="_blank" style="color: #007bff; text-decoration: none;">
                www.t3next.com
              </a>
              , Prishtinë, Kosovë.
            </span>
          </div>
        </div>

        `;


      // 3️⃣ Përgatitim objektin emailObj
      const emailObj = {
        server: 'smtp.t3next.com',
        company: settings.companyName,
        replay: settings.email,
        email: partner.email,
        subject: sale.invoiceNo,
        atach: pdfBase64, // ky është Base64 i PDF-it
        filename: sale.invoiceNo,
        text: this.convertNewlinesToHtml(this.replacePlaceholders(settings.emailText, replacements)) + footerNote || `
           <main role="main">
              <div class="card-content">
                <p>Përshëndetje ${partner.companyName}, </p>  
                <p>Ju lutemi gjeni të bashkangjitur faturën me numër <strong>${sale.invoiceNo}</strong>, të lëshuar më <strong>${helper().formatDate(sale?.date, 'dd.MM.yyyy')}</strong> nga kompania <strong>${settings.companyName}</strong>.</p>  
                <p>Për çdo paqartësi apo informacion shtesë, mund të na kontaktoni në adresën: <a href="mailto:${settings.email}" rel="noopener noreferrer" target="_blank">${settings.email}</a>.</p>  
                
                <p>Faleminderit për bashkëpunimin!</p>
              </div>
              ${footerNote}
          </main>`,
      };

      // 4️⃣ Dërgojmë përmes API
      const response = await apiService().postConfirmation(emailObj);
      if (response.success) {
        this.props.addToast(helper().translate(response.message), { appearance: 'success', autoDismiss: true, });
      } else {
        this.props.addToast(helper().translate("EMAIL_SEND_FAILED") + response.error, { appearance: 'error', autoDismiss: true, });
      }

    } catch (error) {
      this.props.addToast(helper().translate("EMAIL_SEND_ERROR") + error, { appearance: 'error', autoDismiss: true, });
    } finally {
      this.setState({ isSending: false })
    }
  };

  // Helper function për me konvertu Blob në Base64
  blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result.split(',')[1]); // vetëm Base64 pa "data:application/pdf;base64,"
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  getUserColumns = () => {
    apiService().query('userColumns', `username=${this.state.logedInUser.data.username}&formname=${this.formName}`)
      .then(response => {
        if (response.success && response.data.length > 0) {
          let results = response.data[0].hColumns.split(',')
          this.setState({ userColumns: results });
          this.setColumns(results)
        }
        else {
          this.setColumns();
        }
      })
  }

  setColumns = (userColumns) => {
    var hdrs = []
    let countFalseHdrs = 0;
    this.headers.forEach(h => {
      if (userColumns) {
        // userColumns.includes(h?.key) ? h['showHidde'] = true : h['showHidde'] = false ;
        if (userColumns.includes(h?.key)) {
          h['showHidde'] = true;
        } else {
          h['showHidde'] = false;
          countFalseHdrs++;
        }
      }
      else {
        h ? h['showHidde'] = true : 0;
      }
      hdrs.push(h)
    })
    this.setState({ uncheckedHdrs: countFalseHdrs });
    this.setState({ showedHeaders: hdrs });
  }

  removeColumn = (key) => {
    let arr = []
    this.state.showedHeaders.forEach(h => {
      if (h.key === key) h.showHidde = !h.showHidde
      arr.push(h)
    })
    // this.renderHeader(arr)
    this.setState({ showedHeaders: arr });
    this.savePrepare(arr)
  }

  savePrepare = (hs) => {
    if (this.formName) {
      let hc = []
      let headers = hs ? hs : showedHeaders
      headers?.forEach(h => {
        h.showHidde ? hc.push(h.key) : ''
      })
      let obj = { userName: this.state.logedInUser.data.username, formName: this.formName, hColumns: hc.toString() }
      this.saveUserColumns(obj, hc.to)
    }
  }

  saveUserColumns = (obj) => {
    if (!this.state.userColumns.length && !this.allAreTrue(this.state.showedHeaders)) {
      apiService().post('userColumns', obj)
        .then(response => {
          this.getUserColumns()
        })
    }
    else if (this.state.userColumns.length && obj.hColumns !== this.state.userColumns.toString()) {
      apiService().put('userColumns', obj)
        .then(response => {
          if (response.success) {
            this.getUserColumns()
          }
        })
    }
  }

  allAreTrue = (arr) => {
    return arr.every(element => element.showHidde === true);
  }

  checkHeader = (key) => {
    var find = this.state.showedHeaders?.find(s => s.key === key);
    if (find) {
      return find['showHidde'];
    }
    else {
      return true;
    }
  }

  renderColumns = () => {
    var headersMap = this.state.showedHeaders ? this.state.showedHeaders : this.headers;
    return headersMap.map((header, index) => {
      return <div className='cursor-pointer' onClick={() => this.removeColumn(header.key)}><input className='me-2' type="checkbox" checked={header.showHidde ? 'checked' : ''} name={header.key}></input><label>{header.key}</label></div>
    });
  }


  render() {
    const { saleDetails, paymentSales, warehouse, salesType, payMethod, partners, items, units, vatLevel, projects, banksPos, invoiceForm, fullItems, branches, partnersFull, itemSaleOtherDetails, saleVatTypes, cities } = this.state;

    // const warehouseOptions = warehouse.map((item, index) => ({
    //     value: item.id,
    //     label: item.name
    //   }));
    const partnerOptions = partners.map((item, index) => ({

      value: item.id,
      label: item.companyName,
      fiscalNo: item.fiscalNo,
      cityName: item.cityName,
      saveAs: item.saveAs,
      isDisabled: item.isDisabled ? item.isDisabled : false
    }))

    const partnerOptionsFull = partnersFull.map((item, index) => ({
      value: item.id,
      label: item.companyName,
      fiscalNo: item.fiscalNo,
      cityName: item.cityName,
      saveAs: item.saveAs,
      isDisabled: item.isDisabled ? item.isDisabled : false
    }))


    const banksPosOption = banksPos.map((item, index) => ({
      value: item.id,
      label: item.name
    }))
    const projectsOptions = projects.map((item, index) => ({
      value: item.id,
      label: item.name
    }))
    const citiesOptions = cities.map((item, index) => ({
      value: item.id,
      label: item.name
    }))
    const salesOptions = salesType.map((item, index) => ({
      value: item.id,
      label: item.name
    }));
    const payOptions = payMethod.map((item, index) => ({
      value: item.id,
      label: item.name
    }));
    const itemOptions = items.map((item, index) => ({
      value: item.id,
      label: item.itemName,
      barcode: item.barcode,
      quantity: item.quantity,
      productNo: item.productNo,
      avgPrice: index > 0 ? parseFloat(item.avgPrice).toFixed(2) : item.avgPrice,
      priceWithVat: index > 0 ? parseFloat(item.priceWithVat).toFixed(2) : item.priceWithVat,
      isDisabled: item.isDisabled ? item.isDisabled : false,
      status: item.status,
      vat: item.vat
    }))
    const saleVatOptions = saleVatTypes.map((item, index) => ({
      value: item.id,
      label: item.name,
      vat: item.vat
    }))
    const fullItemBarcodeOptions = fullItems.map((item, index) => ({
      value: item.id,
      label: item.barcode
    }))
    const itemNameOptions = items.map((item, index) => ({
      value: item.id,
      label: item.itemName
    }))
    const fullIemNameOptions = fullItems.map((item, index) => ({
      value: item.id,
      label: item.itemName
    }))
    const unitsOptions = units.map((item, index) => ({
      value: item.typeId,
      label: item.name
    }))

    const styles = {
      container: provided => ({
        ...provided,
        minWidth: '120px'
      }),
      control: (provided, state) => ({
        ...provided,
        background: '#fff',
        borderColor: '#9e9e9e',
        minHeight: '28.59px',
        height: '28.59px',
        boxShadow: state.isFocused ? null : null,
      }),
      menuPortal: base => ({ ...base, zIndex: 9999 }),
      valueContainer: (provided, state) => ({
        ...provided,
        height: '28.59px',
        padding: '0 6px'
      }),

      input: (provided, state) => ({
        ...provided,
        margin: '0px',
      }),
      indicatorSeparator: state => ({
        display: 'none',
      }),
      indicatorsContainer: (provided, state) => ({
        ...provided,
        height: '28.59px',
      }),
    };
    const styleForVatForm = {
      container: provided => ({
        ...provided,
        minWidth: '60px'
      }),
      option: (provided, state) => ({
        ...provided,
        fontWeight: state.isDisabled ? 'bold' : 'normal',
        color: state.isDisabled ? 'black' : state.isSelected ? 'white' : '#858796',
        background: state.isDisabled && '#d3d3d3',

      }),
      control: (provided, state) => ({
        ...provided,
        background: "#fff",
        borderColor: "#9e9e9e",
        minHeight: "28.59px",
        height: "28.59px",
        boxShadow: state.isFocused ? null : null,
      }),
      menu: (provided, state) => ({
        ...provided,
        width: "auto",
        marginLeft: "-50px"
      }),
      menuList: (provided, state) => ({
        ...provided,
        width: "350px"
      }),

      valueContainer: (provided, state) => ({ ...provided, height: "28.59px", padding: "0 6px", }),
      input: (provided, state) => ({ ...provided, margin: "0px", }), indicatorSeparator: (state) => ({ display: "none", }),
      indicatorsContainer: (provided, state) => ({ ...provided, height: "28.59px", }),
    };
    const multipleItemStyle = {
      container: provided => ({
        ...provided,
        minWidth: '170px'
      }),
      option: (provided, state) => ({
        ...provided,
        fontWeight: state.isDisabled ? 'bold' : 'normal',
        color: state.isDisabled ? 'black' : state.isSelected ? 'white' : '#000',
        background: state.isDisabled && '#d3d3d3',

      }),
      control: (provided, state) => ({
        ...provided,
        background: "#fff",
        borderColor: "#9e9e9e",
        minHeight: "28.59px",
        height: "28.59px",
        boxShadow: state.isFocused ? null : null,
      }),
      menu: (provided, state) => ({
        ...provided,
        width: "auto"
        //  marginTop: "30px"
      }),
      menuList: (provided, state) => ({
        ...provided,
        width: "auto"
      }),

      valueContainer: (provided, state) => ({ ...provided, height: "28.59px", padding: "0 6px", }),
      input: (provided, state) => ({ ...provided, margin: "0px", }), indicatorSeparator: (state) => ({ display: "none", }),
      indicatorsContainer: (provided, state) => ({ ...provided, height: "28.59px", }),
    };
    const partnerOption = props => {
      return (
        <components.Option {...props}>

          <div className="d-flex text-truncate">
            <p style={{ width: ` ${250}px` }} className="m-0 text-left ">{props.data.label}</p>|<p style={{ width: ` ${300}px` }} className="m-0 text-center ">{props.data.saveAs}</p>|<p style={{ width: ` ${190}px` }} className="m-0 text-center ">{props.data.fiscalNo}</p>|<p style={{ width: ` ${180}px` }} className="m-0 text-center ">{props.data.cityName}</p></div>
        </components.Option>
      );
    };

    const calculatePriceWithVat = (price, vat) => {
      if (!isNaN(parseFloat(price)) && isFinite(Number(price))) {
        return parseFloat(Number(price) + (Number(price) * Number(vat) / 100)).toFixed(2);
      } else {
        return price
      }
    }

    const itemOption = props => {
      return (
        <components.Option {...props}>
          <div className="d-flex text-truncate">
            <p style={{ width: ` ${250}px` }} className="m-0 text-left text-wrap ">{props.data.label}</p>|
            <p style={{ width: ` ${100}px` }} className="m-0 text-center ">{props.data.quantity}</p>|
            <p style={{ width: ` ${100}px` }} className="m-0 text-center ">{props.data.barcode}</p>
            {this.state.userSettings?.avgPriceAndPrice && '|'}
            {this.state.userSettings?.avgPriceAndPrice && <p style={{ width: ` ${200}px` }} className="m-0 text-center ">{calculatePriceWithVat(props.data.avgPrice, props.data.vat)}</p>}
            {this.state.userSettings?.avgPriceAndPrice && '|'}
            {this.state.userSettings?.avgPriceAndPrice && <p style={{ width: ` ${200}px` }} className="m-0 text-center ">{props.data.priceWithVat}</p>}
          </div>
        </components.Option>
      );
    };

    const customFilterBuyerOption = (option, inputValue) => {
      // Customize the filter logic here based on your desired columns to search
      const labelMatches = option.data?.label?.toLowerCase().includes(inputValue.toLowerCase());
      const fiscalNoMatches = option.data?.fiscalNo?.toLowerCase().includes(inputValue.toLowerCase());
      const cityNameMatches = option.data?.cityName?.toLowerCase().includes(inputValue.toLowerCase());
      const saveAsMatches = option.data?.saveAs?.toLowerCase().includes(inputValue.toLowerCase());
      // const headerReturn = option.filter(f => f.value == null);

      return labelMatches || fiscalNoMatches || cityNameMatches || saveAsMatches || option.data.value == null;
    };
    const customFilterItemOption = (option, inputValue) => {
      const labelMatches = option.data?.label?.toLowerCase().includes(inputValue.toLowerCase());
      const barcodeMatches = option.data?.barcode?.toLowerCase().includes(inputValue.toLowerCase());
      const productNoMatches = option.data?.productNo?.toLowerCase().includes(inputValue.toLowerCase());

      return labelMatches || barcodeMatches || productNoMatches;
    };

    const checkColumnsModal = () => {
      if (this.state.showHiddeBox) this.setState({ showHiddeBox: false })
    }

    const formatDecimal = (e, no) => {
      const inputValue = parseFloat(e.target.value).toFixed(4);
      const formattedValue = parseFloat(inputValue).toFixed(4);
      if (formattedValue.slice(-2) === "00") {
        const finalValue = parseFloat(formattedValue).toFixed(2);
        const updatedDetails = [...this.state.saleDetails];
        updatedDetails[no - 1].priceTvsh = finalValue;
        this.setState({ saleDetails: updatedDetails });
      } else {
        const updatedDetails = [...this.state.saleDetails];
        updatedDetails[no - 1].priceTvsh = formattedValue;
        this.setState({ saleDetails: updatedDetails });
      }
    }

    const exportToExcel = (fileName) => {
      this.excelExportRef.current.exportToExcel(fileName);
    };

    const headersForExcelFile = () => {
      const columns = [
        { key: 'no', columName: 'NR' },
        { key: 'itemName', columName: 'ITEM' },
        { key: 'unitName', columName: 'UNIT' },
        { key: 'quantity', columName: 'QUANTITY' },
        { key: 'price', columName: 'PRICE' },
        { key: 'discount', columName: 'DISCOUNT' },
        { key: 'priceDiscount', columName: 'PRICE_WITH_DISCOUNT' },
        { key: 'vat', columName: 'VAT' },
        { key: 'vatForm', columName: 'VAT_FORM' },
        { key: 'priceTvsh', columName: 'PRICE_WITH_VAT' },
        { key: 'totalPrice', columName: 'TOTAL', calculate: true },
        { key: 'vatSum', columName: 'VAT_VALUE', calculate: true },
        { key: 'totalPriceTvsh', columName: 'TOTAL_WITH_VAT', calculate: true },
      ];

      // krijon dinamikisht me translate() dhe showHidde default
      return columns.map(col => ({
        key: col.key,
        columnName: helper().translate(col.columName),
        showHidde: true,
        calculate: col.calculate ? col.calculate : false,
        //type: col.type ? col.type : ''
      }));
    };

    const improveSaleDetails = (saleDetails, unitsOptions) => {
      return saleDetails.map((sd, index) => {
        const unit = unitsOptions.find(u => u.value === sd.unitId);
        return {
          ...sd,
          unitName: unit ? unit.label : '',
          vatForm: saleVatOptions.find(i => i.value === sd.vatForm)?.label || '',
        };
      });
    };

    const isSalePrint = {
      partner: partnerOptionsFull.find(partner => partner.value == (this.state.sale.partnerId != null ? this.state.sale.partnerId : ''))?.label,
      invoiceNo: this.state.sale.invoiceNo,
      saleType: salesOptions.find(s => s.value == this.state.sale.salesTypeId)?.label,
      reference: this.state.sale.reference,
      comments: this.state.sale.comments,
      warehouse: warehouse.find(w => w.id == this.state.sale.warehouseId)?.name,
      date: helper().formatDate(this.state.sale.date, 'dd.MM.yyyy'),
      type: "isSalePrint"
    }

    let that = this;
    return (
      <div>
        <ExcelExport data={improveSaleDetails(saleDetails, unitsOptions) || []} headers={headersForExcelFile() || []} type={'other'} ref={that.excelExportRef} hideContent={true} />
        {!this.state.loader && saleDetails.length > 0 && <Print data={improveSaleDetails(saleDetails, unitsOptions) || []} headers={headersForExcelFile() || []} query={isSalePrint} ref={that.printRef} reportName={this.state.sale.invoiceNo} formName={that.formName} includeAllHeader={true} />}
        <div id="Sale" className={this.state.paymentBtn.showPayFrom || this.state.paymentBtn.showPayments || this.state.otherSalesDetails ? "d-none" : ""}>
          <div className="container-fluid px-2 mt-3">
            <Search headersFrom={"SALES"} search={false} printClick={() => this.print(this.state.sale, invoiceForm)} digitalPrint={() => this.digitalPrint(this.state.sale, invoiceForm)} save={this.saveSale} newHandle={this.newHandle} new={`#/sale/0/type?${this.state.sale?.salesTypeId}`} backHandle={this.backHandle} back="#/sales" sendToEmail={() => this.sendToEmail()} isSending={this.state.isSending} excel={this.state.sale.id ? () => exportToExcel(this.state.sale.invoiceNo) : ''} />
          </div>
          {this.state.loader && <LoaderComponent />}
          {!this.state.loader && <div onClick={() => checkColumnsModal()}> <div className="container-fluid px-2 ">
            <div className="card border-left-primary shadow h-100 mt-1 pt-1 pb-3">
              <div className="form  px-4" >
                <div className="row ps-2 ">
                  <div className="col-md-9 col-12">
                    <div className="row">
                      <div className="col-md-4 col-12 pl-0">
                        <div className="row align-items-center">
                          <div className="col">
                            <label className="text-xs font-weight-bold text-primary mb-0">
                              {helper().translate("BUYER")}
                            </label>
                            <Select
                              name="partnerId"
                              openMenuOnFocus={true}
                              components={{ Option: partnerOption }}
                              className={this.state.validate ? this.state.sale.partnerId == null ? "is-invalid-s" : '' : ''}
                              placeholder={helper().translate("CHOOSE_THE_BUYER")}
                              value={partnerOptionsFull.find(partner => partner.value == (this.state.sale.partnerId != null ? this.state.sale.partnerId : '')) || ''}
                              onChange={this.onSelectChange}
                              options={partnerOptions}
                              filterOption={customFilterBuyerOption}
                              styles={multipleItemStyle}
                            />
                            {/* { this.state.validate ? this.state.sale.partnerId == null ? <span className="text-center text-danger small">ju lutem zgjidheni bleresin</span> : '' : '' } */}
                          </div>
                          <SaleAddPartner onClose={this.getPartners} props={that.props} />
                        </div>
                      </div>
                      <div className="col-md-4 col-12 pl-0">
                        <div className="">
                          <label className="text-xs font-weight-bold text-primary mb-0">
                            {helper().translate("SALE_TYPE")}
                          </label>
                          <Select
                            name="salesTypeId"
                            openMenuOnFocus={true}
                            //isDisabled
                            placeholder="Zgjedh Tipin"
                            className={this.state.validate ? this.state.sale.salesTypeId == null ? "is-invalid-s" : '' : ''}
                            value={salesOptions?.find(s => s.value == this.state.sale.salesTypeId)}
                            // defaultValue={salesOptions?.find(s => s.value == (this.props.location.search).substring(1,this.props.location.length))}
                            onChange={this.onSelectChange}
                            options={salesOptions}
                            styles={styles} />
                          {/* {console.log((this.props.location.search).substring(1,this.props.location.length))} */}
                          {/* {this.state.validate ? this.state.sale.salesTypeId == null ? <span className="text-center text-danger small">zgjidheni tipin shitjes</span> : '' : ''} */}
                        </div>
                      </div>

                      <div className="col-md-4 col-12 l-straight pl-0">
                        <div className="">
                          <label className="text-xs font-weight-bold text-primary mb-0">
                            {helper().translate("INVOICE_NO")}
                          </label>
                          <input
                            className={`form-control form-control-sm ${this.state.sale?.invoiceExist ? 'is-invalid' : ''}`}
                            name="invoiceNo"
                            type="text"
                            disabled={this.state.invoiceIdFormat === false ? false : true}
                            onChange={this.onFieldChange}
                            value={this.state.sale?.invoiceNo}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-2 col-12 pl-0">
                        <label className="text-xs font-weight-bold text-primary mb-0">
                          {helper().translate("REFERENCE")}
                        </label>
                        <input
                          className={`form-control form-control-sm ${this.state.sale?.referenceExist ? 'is-invalid' : ''}`}
                          name="reference"
                          type="text"
                          onChange={this.onFieldChange}
                          value={this.state.sale?.reference}
                        />

                      </div>
                      {this.state.sale.salesTypeId === 1 &&
                        <div className="col-md-2 col-12 pl-0 mt-2 d-flex align-items-end justify-content-center" ><button onClick={this.onButtonClickOtherSD} style={{ height: "28.6px", fontSize: "12px" }} className="btn  btn-secondary text-capitalize font-weight-bold   text-nowrap">{helper().translate("OTHER_DETAILS")}</  button>
                        </div>}

                      <div className="col-md-4 col-12 pl-0">
                        <div className="row">
                          <div className={` ${this.isitExport() ? 'col-md-8 ' : 'col-md-12 '}col-12 `}>
                            <label className="text-xs font-weight-bold text-primary mb-0">
                              {helper().translate("INVOICE_DATE")}
                            </label>
                            <input
                              name="date"
                              className={this.state.validate ? this.state.sale.date == '' ? "form-control form-control-sm is-invalid" : 'form-control form-control-sm ' : 'form-control form-control-sm '}
                              type="date"
                              value={helper().isValidDate(this.state.sale?.date) ? this.state.sale.date.toISOString().substring(0, 10) : ''}
                              onChange={this.onFieldChange}
                            />
                            {/* { this.state.validate ? this.state.sale.date == '' ? <span className="text-center text-danger small">zgjidheni daten</span> : '' : '' } */}
                          </div>
                          { /*this.isitExport() &&  <div className="col-md-4 col-12 pl-0">
                          <div className=" d-flex flex-column align-items-center">
                            <label className="text-xs font-weight-bold text-primary mt-2 mb-0">
                            {helper().translate("WITH_VAT")}
                            </label>
                            <div className="text-light">
                            <Switch      
                             name="withVat"                     
                             onColor="#86d3ff"
                             offColor="#000000"
                             onHandleColor="#000000"
                             handleDiameter={25}
                             width={55}
                             height={20}
                             uncheckedIcon={<span style={{display:'flex', margin: '-4px 0 0 -5px'}}>{helper().translate("NO")}</span>}
                             checkedIcon={<span style={{display:'flex', margin: '-4px 0 0 -5px'}}>{helper().translate("YES")}</span>}
                             padding="7px 0px"
                             boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                             activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                             onChange={this.withVatChanged} 
                             checked={this.state.sale.withVat}
                            />
                            </div>
                          </div>
                        </div> */}

                        </div>
                      </div>
                      <div className="col-md-2 col-12 pl-0">
                        <div className="">
                          <label className="text-xs font-weight-bold text-primary mb-0">
                            {helper().translate("WAREHOUSE")}
                          </label  >
                          {/* <Select 
                        name="warehouseId" 
                        openMenuOnFocus={true}
                        className={ this.state.validate ? this.state.sale.warehouseId == null ? "is-invalid-s" : '' : ''}
                        // placeholder="Zgjedh Tipin" 
                        value={warehouseOptions?.find(ware => ware.value == this.state.sale.warehouseId) }  
                        onChange={this.onSelectChange} 
                        options={warehouseOptions}
                        styles={styles}  
                        isDisabled={!this.state.userSettings?.allowToChangeWarehouse}
                        /> */}
                          <SelectByGroup
                            name="warehouseId"
                            className={this.state.validate ? this.state.sale.warehouseId == null ? "is-invalid-s" : '' : ''}
                            parent={branches}
                            child={warehouse}
                            childParentId={"branchId"}
                            placeholder={helper().translate("CHOOSE_WAREHOUSE")}
                            styles={styles}
                            isDisabled={!this.state.userSettings?.allowToChangeWarehouse}
                            onChange={this.onSelectChange}
                            value={this.state.sale.warehouseId}
                          />
                          {/* { this.state.validate ? this.state.sale.warehouseId == null ? <span className="text-center text-danger small">zgjidheni depon</span> : '' : '' } */}
                        </div>
                      </div>

                    </div>

                  </div>
                  <div className="text-box d-sm-none d-none d-md-block col-3  pl-0">
                    <label className="text-xs font-weight-bold text-primary mb-0">
                      {helper().translate("COMMENT")}
                    </label>
                    <br></br>
                    <textarea
                      className="textareas form-control h-81"
                      name="comment"
                      // defaultValue={this.state.sale.comment}
                      value={this.state.sale.comment}
                      onChange={this.onFieldChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div className="container-fluid px-2 mt-1">
              <div className="card shadow mt-1">
                <div className="card-header py-2">
                  {/* <h6 className="m-0 font-weight-bold text-primary">{helper().translate("INVOICE")}</h6> */}
                </div>
                {
                  this.state.showHiddeBox && <div className='datatable-columns' style={{ margin: '50px' }}>
                    {this.renderColumns()}
                  </div>
                }
                <div className="card-body table-responsive p-0 mt-1">
                  <table onKeyPress={this.addRowEnter} className="table table-hover text-center sales-table">
                    <thead>
                      <tr>
                        <th style={{ width: "45px" }}>{helper().translate("NR")} <i className="fas fa-ellipsis-v float-right mx-2 mt-1 cursor-pointer" onClick={() => this.setState({ showHiddeBox: !this.state.showHiddeBox })}></i></th>
                        {this.state.sale.isDraft ? <th>{helper().translate("DATE")}</th> : null}
                        {/* <th>{helper().translate("BARCODE")}</th> */}
                        <th style={{ width: "120px" }}>{helper().translate("ITEM")}</th>
                        {(this.state.sale.isDraft || this.checkHeader(helper().translate('DESCRIPTION'))) ? <th>{helper().translate("DESCRIPTION")}</th> : null}
                        {/* <th>Njesia</th> */}
                        {this.checkHeader(helper().translate('LOCATION')) && <th>{helper().translate("LOCATION")}</th>}
                        {this.checkHeader(helper().translate('COMMENT')) && <th>{helper().translate("COMMENT")}</th>}
                        {this.checkHeader(helper().translate('PROJECT')) && <th>{helper().translate("PROJECT")}</th>}
                        {this.checkHeader(helper().translate('UNIT')) && <th>{helper().translate("UNIT")}</th>}
                        {this.checkHeader(helper().translate('QUANTITY')) && <th>{helper().translate("QUANTITY")}</th>}
                        <th className="text-truncate ">{helper().translate("PRICE_WITHOUT_VAT")}</th>
                        {this.checkHeader(helper().translate('DISCOUNT')) && <th className="text-truncate ">{helper().translate("DISCOUNT")} %</th>}
                        {this.state.allowMultipleDiscount && this.checkHeader(helper().translate('DISCOUNT')) && <th className="text-truncate ">{helper().translate("DISCOUNT")}2 %</th>}
                        {this.state.allowMultipleDiscount && this.checkHeader(helper().translate('DISCOUNT')) && <th className="text-truncate ">{helper().translate("DISCOUNT")}3 %</th>}
                        {this.state.allowMultipleDiscount && this.checkHeader(helper().translate('DISCOUNT')) && <th className="text-truncate ">{helper().translate("DISCOUNT")}4 %</th>}

                        {this.checkHeader(helper().translate('DISCOUNT')) && <th className="text-truncate ">{helper().translate("PRICE_WITH_DISCOUNT")}</th>}
                        {this.state.sale.withVat ? <th style={{ width: '65px' }} >{helper().translate("VAT")} %</th> : ''}
                        {this.notAllowedVatForm() && this.checkHeader(helper().translate('VAT_FORM')) ? <th>{helper().translate("VAT_FORM")} </th> : ""}
                        {this.state.sale.withVat ? <th className="text-truncate ">{helper().translate("PRICE_WITH_VAT")}</th> : ''}
                        <th >{helper().translate("TOTAL")}</th>
                        {this.state.sale.withVat ? <th className="text-truncate ">{helper().translate("VAT_VALUE")}</th> : ''}
                        {this.state.sale.withVat ? <th className="text-truncate " >{helper().translate("TOTAL_WITH_VAT")}</th> : ''}
                        <th>{helper().translate("ADD")}</th>
                        <th>{helper().translate("DELETE")}</th>
                      </tr>
                    </thead>
                    <tbody className='pb-5' >
                      {saleDetails.map((item, key) =>

                        <tr key={item.no} className="mainTable">
                          <td style={{ width: "45px" }}>{item.no}</td>
                          {/* Date */}
                          {this.state.sale.isDraft ? item.editMode ? <td  >
                            <input
                              name="date"
                              className="form-control form-control-sm text-center "
                              onChange={(e, obj) => that.onFieldDetailsChange(e, obj, item.no)}
                              type="date"
                              value={helper().isValidDate(this.state.saleDetails[item.no - 1].date) ? this.state.saleDetails[item.no - 1].date.toISOString().substring(0, 10) : ''}
                            />
                          </td> : <td onClick={function () { that.rowClick(item.no) }}><span className="text-center text-dark small">{item.date ? item?.date.toISOString().substring(0, 10) : helper().translate("CHOOSE_DATE")}</span> </td> : null}
                          {/* Barcode */}
                          {
                            item.editMode ?
                              <td>
                                <Select
                                  openMenuOnFocus={true}
                                  components={{ Option: itemOption }}
                                  menuPortalTarget={document.body}
                                  // className={this.state.validate ? this.state.sale.partnerId == null ? "is-invalid-s" : '' : '' }
                                  // placeholder={helper().translate("CHOOSE_THE_BUYER")}
                                  value={fullIemNameOptions.find(i => i.value === item.itemId)}
                                  onChange={function (e, obj) { that.itemChange(e, obj, item.no) }}
                                  options={itemOptions}
                                  filterOption={customFilterItemOption}
                                  styles={multipleItemStyle}
                                />
                                {item.validate ? '' : ''}</td>
                              :
                              <td onClick={function () { that.rowClick(item.no) }}>
                                {item.validate === false ? item?.itemId === 0 ? <span className="text-center text-danger small">{helper().translate("CHOOSE")}</span> : item.itemName.substring(0, 25) : item.itemName.substring(0, 25)}
                              </td>
                          }
                          {/* description */}
                          {(this.state.sale.isDraft || this.checkHeader(helper().translate('DESCRIPTION'))) ? item.editMode ? <td style={{ minWidth: "150px" }}>
                            <MDBInput
                              name="description"
                              title={this.state.saleDetails[item.no - 1].description || ''}
                              className="form-control-sm "
                              onChange={(e, obj) => that.onFieldDetailsChange(e, obj, item.no)}
                              type="text"
                              value={this.state.saleDetails[item.no - 1].description || ''}
                            />
                          </td> : <td onClick={function () { that.rowClick(item.no) }}>{item?.description?.substring(0, 20)}</td> : null}
                          {/* ItemName / artikullit */}
                          {/* { 
                        item.editMode ?  
                        <td><Select openMenuOnFocus={true}  styles={styles} menuPortalTarget={document.body}  value={fullIemNameOptions.find(i => i.value === item.itemId)}  
                         onChange={ (e,obj)=> that.itemChange(e,obj,item.no)}  options={itemNameOptions} ></Select>{item.validate ? '' : '' }</td>
                          : 
                        <td onClick={function(){ that.rowClick(item.no)}}>
                          {item.validate === false ? item?.itemId === 0 ? <span className="text-center text-danger small">{helper().translate("CHOOSE_ITEM")}</span> : item.itemName.substring(0,25) : item.itemName.substring(0,25) }
                          </td>

                      }   */}
                          {/* Vendi / vendi */}
                          {
                            item.editMode ?
                              this.checkHeader(helper().translate('LOCATION')) && <td><Select openMenuOnFocus={true} name="cityId" onChange={(e, obj) => that.itemChange(e, obj, item.no)} styles={styles} menuPortalTarget={document.body} value={citiesOptions.find(i => i.value === item.cityId)} options={citiesOptions} ></Select>{item.validate ? '' : ''}</td>
                              :
                              this.checkHeader(helper().translate('LOCATION')) && <td onClick={function () { that.rowClick(item.no) }}>
                                {citiesOptions.find(p => p.value === item?.cityId)?.label}
                              </td>

                          }
                          {/* comment */}
                          {(this.state.sale.isDraft || this.checkHeader(helper().translate('COMMENT'))) ? item.editMode ? <td style={{ minWidth: "150px" }}>
                            <MDBInput
                              name="comment"
                              title={this.state.saleDetails[item.no - 1].comment || ''}
                              className="form-control-sm "
                              onChange={(e, obj) => that.onFieldDetailsChange(e, obj, item.no)}
                              type="text"
                              value={this.state.saleDetails[item.no - 1].comment || ''}
                            />
                          </td> : <td onClick={function () { that.rowClick(item.no) }}>{item?.comment?.substring(0, 20)}</td> : null}
                          {/* Project / projekti */}
                          {
                            item.editMode ?
                              this.checkHeader(helper().translate('PROJECT')) && <td><Select openMenuOnFocus={true} name="projectId" onChange={(e, obj) => that.itemChange(e, obj, item.no)} styles={styles} menuPortalTarget={document.body} value={projectsOptions.find(i => i.value === item.projectId)} options={projectsOptions} ></Select>{item.validate ? '' : ''}</td>
                              :
                              this.checkHeader(helper().translate('PROJECT')) && <td onClick={function () { that.rowClick(item.no) }}>
                                {projectsOptions.find(p => p.value === item?.projectId)?.label}
                              </td>

                          }

                          {/* unitName / njesia */}
                          {/* {item.editMode ? <td><Select isDisabled={true} styles={stylesUnit} value={unitsOptions.find(u => u.value === item.unitId)} options={unitsOptions}  ></Select></td> : <td onClick={function(){ that.rowClick(item.no)}}>{typeof(unitsOptions.find(u => u.value === item.unitId)) !== 'undefined' ? unitsOptions.find(u => u.value === item.unitId).label : ''}</td> } */}

                          {item.editMode ? this.checkHeader(helper().translate('UNIT')) && <td><input style={{ minWidth: "100px" }} type='text' disabled className="form-control form-control-sm text-center w-100 " value={unitsOptions.find(u => u.value === item.unitId)?.label}
                            onChange={function (e, obj) { that.onFieldDetailsChange(e, obj, item.no) }} ></input></td> : this.checkHeader(helper().translate('UNIT')) && <td onClick={function () { that.rowClick(item.no) }}>{typeof (unitsOptions.find(u => u.value === item.unitId)) !== 'undefined' ? unitsOptions.find(u => u.value === item.unitId).label : ''}</td>}


                          {/* Quantity / sasia */}
                          {
                            item.editMode ?
                              this.checkHeader(helper().translate('QUANTITY')) && <td name="quantity" onClick={function () { that.rowClick(item.no) }}><input name="quantity" style={{ minWidth: "100px" }} className={` form-control form-control-sm text-center w-100  ${item.service !== true && this.state.saleDetails[item.no - 1].isntAllowedQuantity === true ? "is-invalid mb-0" : ""}`} type="number" value={this.state.saleDetails[item.no - 1].quantity} onChange={(e, obj) => that.onFieldDetailsChange(e, obj, item.no)}></input></td>
                              :
                              this.checkHeader(helper().translate('QUANTITY')) && <td className={`${item.service !== true && item.isntAllowedQuantity === true ? "is-invalid-i" : ""}`} onClick={function () { that.rowClick(item.no) }}>{item.quantity}</td>

                          }
                          {/* Price / qmimi pa tvsh*/}

                          {item.editMode ? <td><input name="price" style={{ width: '100%' }} className="form-control form-control-sm text-center " min="0" type="number" value={helper().toFixed2("price", this.state.saleDetails[item.no - 1].price, true)} onChange={(e, obj) => that.onFieldDetailsChange(e, obj, item.no)}></input></td> : <td onClick={function () { that.rowClick(item.no) }}>{typeof (item.price) != 'undefined' ? helper().formatNumber(parseFloat(item.price), true) : item.price}</td>}





                          {/* Discount / zbritja*/}
                          {item.editMode ? this.checkHeader(helper().translate('DISCOUNT')) && <td><input name="discount" style={{ minWidth: "100px" }} className="form-control form-control-sm text-center " type="number" defaultValue={0} value={helper().toFixed2("discount", this.state.saleDetails[item.no - 1].discount)} min="0" max="100" onChange={(e, obj) => that.onFieldDetailsChange(e, obj, item.no)}></input></td> : this.checkHeader(helper().translate('DISCOUNT')) && <td onClick={function () { that.rowClick(item.no) }}>{item.discount}</td>}
                          {/* Discount2 / zbritja*/}
                          {this.state.allowMultipleDiscount ? item.editMode ? this.checkHeader(helper().translate('DISCOUNT')) && <td><input name="discount2" style={{ minWidth: "100px" }} className="form-control form-control-sm text-center " type="number" defaultValue={0} value={helper().toFixed2("discount2", this.state.saleDetails[item.no - 1].discount2)} min="0" max="100" onChange={(e, obj) => that.onFieldDetailsChange(e, obj, item.no)}></input></td> : this.checkHeader(helper().translate('DISCOUNT')) && <td onClick={function () { that.rowClick(item.no) }}>{item.discount2}</td> : null}
                          {/* Discount3 / zbritja*/}
                          {this.state.allowMultipleDiscount ? item.editMode ? this.checkHeader(helper().translate('DISCOUNT')) && <td><input name="discount3" style={{ minWidth: "100px" }} className="form-control form-control-sm text-center " type="number" defaultValue={0} value={helper().toFixed2("discount3", this.state.saleDetails[item.no - 1].discount3)} min="0" max="100" onChange={(e, obj) => that.onFieldDetailsChange(e, obj, item.no)}></input></td> : this.checkHeader(helper().translate('DISCOUNT')) && <td onClick={function () { that.rowClick(item.no) }}>{item.discount3}</td> : null}
                          {/* Discount4 / zbritja*/}
                          {this.state.allowMultipleDiscount ? item.editMode ? this.checkHeader(helper().translate('DISCOUNT')) && <td><input name="discount4" style={{ minWidth: "100px" }} className="form-control form-control-sm text-center " type="number" defaultValue={0} value={helper().toFixed2("discount4", this.state.saleDetails[item.no - 1].discount4)} min="0" max="100" onChange={(e, obj) => that.onFieldDetailsChange(e, obj, item.no)}></input></td> : this.checkHeader(helper().translate('DISCOUNT')) && <td onClick={function () { that.rowClick(item.no) }}>{item.discount4}</td> : null}


                          {/* Price with discount / qmimi me zbritje*/}
                          {item.editMode ? this.checkHeader(helper().translate('DISCOUNT')) && <td ><input name="priceDiscount" style={{ width: '100%' }} defaultValue={0} value={helper().toFixed2("priceDiscount", this.state.saleDetails[item.no - 1].priceDiscount, true)} className="form-control form-control-sm text-center " type="number" onChange={(e, obj) => that.onFieldDetailsChange(e, obj, item.no)} ></input></td> : this.checkHeader(helper().translate('DISCOUNT')) && <td onClick={function () { that.rowClick(item.no) }}>{item.discount > 0 ? helper().formatNumber(parseFloat(item.priceDiscount), true) : parseFloat(item.priceDiscount).toFixed(2)}</td>}


                          {/* vat */}
                          {/* {
                        this.state.sale.withVat ? <td><input name="vat"  style={{width: '80px'}} className="form-control form-control-sm text-center " type="number" value={this.state.saleDetails[item.no-1].vat}  onChange={(e,obj)=> that.onFieldDetailsChange(e,obj,item.no)} ></input></td> : ''
                      } */}
                          {item.editMode ? (this.state.sale.withVat ?
                            <td><select
                              name="vat"
                              openMenuOnFocus={true}
                              onChange={(e, obj) => that.onFieldDetailsChange(e, obj, item.no)}
                              className='form-select form-select-sm '
                              value={this.state.saleDetails[item.no - 1].vat}
                              style={{ width: "65px", height: "28.59px" }}

                            >
                              {vatLevel.map(val => {
                                return (
                                  <option value={val.id}>{val.id}</option>
                                )
                              })}
                            </select>
                            </td> : '') : (this.state.sale.withVat ? (<td onClick={function () { that.rowClick(item.no) }}>{item.vat}</td>) : '')}

                          {/* vat-form */}

                          {this.notAllowedVatForm() ? item.editMode ?
                            this.checkHeader(helper().translate('DISCOUNT')) && <td><Select openMenuOnFocus={true} name="vatForm" onChange={(e, obj) => that.itemChange(e, obj, item.no)} styles={styleForVatForm} menuPortalTarget={document.body} value={saleVatOptions.find(i => i.value === item.vatForm)} options={saleVatOptions.filter(i => i.vat == item.vat)} ></Select></td>
                            :
                            this.checkHeader(helper().translate('DISCOUNT')) && <td onClick={function () { that.rowClick(item.no) }}>
                              {<span className="text-center text-dark small">{item.vatForm > 0 ? saleVatOptions?.find(i => i.value === item.vatForm)?.label : 'Zgjidh formularin'}</span>}
                            </td> : ""}


                          {/* PriceTvsh / qmimi me tvsh*/}
                          {item.editMode ? (this.state.sale.withVat ? <td><input name="priceTvsh" style={{ width: '100%' }} className="form-control form-control-sm text-center" defaultValue={0} min="0" type="number" value={this.state.saleDetails[item.no - 1].priceTvsh} onChange={(e, obj) => that.onFieldDetailsChange(e, obj, item.no)} onBlur={(e) => formatDecimal(e, item.no)} ></input></td> : '') : (this.state.sale.withVat ? <td onClick={function () { that.rowClick(item.no) }}>{typeof (item.priceTvsh) != 'undefined' ? helper().formatNumber(parseFloat(item.priceTvsh), true) : item.priceTvsh}</td> : '')}


                          {/* TotalPrice / totali pa tvsh*/}

                          {this.state.sale.withVat ?
                            item.editMode ? (<td><input name="totalPrice" disabled style={{ minWidth: "100px" }} className="form-control form-control-sm text-center w-100 " type="number" defaultValue={0} value={helper().toFixed2("totalPrice", this.state.saleDetails[item.no - 1]?.totalPrice, true)} onChange={(e, obj) => that.onFieldDetailsChange(e, obj, item.no)}></input></td>) : (<td onClick={function () { that.rowClick(item.no) }}>{typeof (item.totalPrice) != 'undefined' ? helper().formatNumber(parseFloat(item.totalPrice), true) : item.totalPrice}</td>)
                            :
                            item.editMode ? (<td><input name="totalPrice" style={{ width: '100%' }} className="form-control form-control-sm text-center " type="number" defaultValue={0} value={helper().toFixed2("totalPrice", this.state.saleDetails[item.no - 1]?.totalPrice, true)} onChange={(e, obj) => that.onFieldDetailsChange(e, obj, item.no)}></input></td>) : (<td onClick={function () { that.rowClick(item.no) }}>{typeof (item.totalPrice) != 'undefined' ? helper().formatNumber(parseFloat(item.totalPrice), true) : item.totalPrice}</td>)}


                          {/* vatSum */}
                          {item.editMode ? (this.state.sale.withVat ? <td><input name="vatSum" disabled style={{ width: '100%' }} className="form-control form-control-sm text-center " type="number" value={helper().toFixed2("vatSum", this.state.saleDetails[item.no - 1]?.vatSum, true)} onChange={function (e, obj) { that.itemChange(e, obj, item.no) }}></input></td> : '') : (this.state.sale.withVat ? <td onClick={function () { that.rowClick(item.no) }}>{typeof (item.vatSum) != 'undefined' ? helper().formatNumber(parseFloat(item.vatSum), true) : item.vatSum}</td> : '')}



                          {/* TotalPrice / totali me tvsh*/}
                          {item.editMode ? (this.state.sale.withVat ? <td><input name="totalPriceTvsh" style={{ width: '100%' }} className="form-control form-control-sm text-center " type="number" defaultValue={0} value={helper().toFixed2("totalPriceTvsh", this.state.saleDetails[item.no - 1].totalPriceTvsh, true)} onChange={(e, obj) => that.onFieldDetailsChange(e, obj, item.no)}></input></td> : '') : (this.state.sale.withVat ? <td onClick={function () { that.rowClick(item.no) }}>{typeof (item.totalPriceTvsh) != 'undefined' ? helper().formatNumber(parseFloat(item.totalPriceTvsh), true) : item.totalPriceTvsh}</td> : '')}

                          {/* Add Btn */}
                          {
                            this.state.saleDetails[item.no - 1].addButton ? <td><button className="btn-edit" onClick={this.addItemsForm}><span className="icon text-white-40"><i className="fas fa-plus-circle"></i></span></button></td> : <td></td>
                          }


                          {/* Delete btn */}
                          <td><button className="btn-delete" onClick={() => this.alertnOnDelete(item.no, item.id)}><span className="icon text-white-40">
                            <i className="fas fa-minus-circle"></i>
                          </span></button></td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot className="mb-2 mt-2 table-borderless no-colors">
                      <tr>
                        <td colSpan={this.state.sale.isDraft ? this.state.allowMultipleDiscount ? (12 - this.state.uncheckedHdrs) : (9 - this.state.uncheckedHdrs) : this.state.allowMultipleDiscount ? (10 - this.state.uncheckedHdrs) : (7 - this.state.uncheckedHdrs)}></td>
                        {this.state.sale.withVat ? <th></th> : ''}
                        {this.state.sale.withVat ? <th></th> : ''}
                        {this.state.sale.withVat && this.notAllowedVatForm() ? <th></th> : ''}
                        <td className="font-weight-bold align-middle ">{helper().translate("TOTAL")}:</td>
                        {this.state.sale.withVat ? <td className="text-center" ><input type="text" className="form-control text-center pb-2 px-0" disabled value={typeof (this.state.sale.subTotal) != 'undefined' ? helper().formatNumber(parseFloat(this.state.sale.subTotal)) : this.state.sale.subTotal} defaultValue="0" ></input></td> : ''}
                        {this.state.sale.withVat ? <td className="text-center"><input type="text" className="form-control text-center px-0" disabled value={typeof (this.state.sale.vatSum) != 'undefined' ? helper().formatNumber(parseFloat(this.state.sale.vatSum)) : this.state.sale.vatSum} defaultValue="0" ></input></td> : ''}

                        {<td className="text-center"><input type="text" className="form-control text-center px-0 " disabled value={typeof (this.state.sale?.totalSum) != 'undefined' ? helper().formatNumber(parseFloat(this.state.sale.totalSum)) : this.state.sale.totalSum} defaultValue="0" ></input></td>}
                        <td colSpan={2} className={this.props.match.params.id == 0 ? "font-weight-bold align-middle" : "d-none"} ><button onClick={this.onButtonClickPay} style={{ height: "28.6px", fontSize: "12px" }} className="btn  btn-primary text-capitalize font-weight-bold align-middle p-1 text-nowrap">{helper().translate("PAYMENT")}</  button></td>
                        <td colSpan={2} className={this.props.match.params.id > 0 ? "font-weight-bold align-middle" : "d-none"}><button onClick={this.onButtonClickPayments} style={{ height: "28.6px", fontSize: "12px" }} className="btn  btn-primary text-capitalize w-100  ">{helper().translate("PAYMENT")}</  button></td>
                      </tr>
                      <tr>
                        {this.notAllowedVatForm() && <td></td>}
                        {this.state.sale.isDraft ? <td colSpan={this.state.sale.withVat ? this.state.allowMultipleDiscount ? (16 - this.state.uncheckedHdrs) : (13 - this.state.uncheckedHdrs) : this.state.allowMultipleDiscount ? (11 - this.state.uncheckedHdrs) : (8 - this.state.uncheckedHdrs)}></td> : <td colSpan={this.state.sale.withVat ? this.state.allowMultipleDiscount ? (14 - this.state.uncheckedHdrs) : (11 - this.state.uncheckedHdrs) : this.state.allowMultipleDiscount ? (9 - this.state.uncheckedHdrs) : (6 - this.state.uncheckedHdrs)}></td>}
                        <td className="font-weight-bold align-middle ">{helper().translate("PAYMENT_TOTAL")}:</td>
                        {<td className="text-center"><input type="text" className="form-control text-center px-0 " disabled value={helper().formatNumber(parseFloat(this.state.sale?.totalSalePayment))} ></input></td>}

                      </tr>
                      <tr>

                        {this.notAllowedVatForm() && <td></td>}
                        {this.state.sale.isDraft ? <td colSpan={this.state.sale.withVat ? this.state.allowMultipleDiscount ? (16 - this.state.uncheckedHdrs) : (13 - this.state.uncheckedHdrs) : this.state.allowMultipleDiscount ? (11 - this.state.uncheckedHdrs) : (8 - this.state.uncheckedHdrs)}></td> : <td colSpan={this.state.sale.withVat ? this.state.allowMultipleDiscount ? (14 - this.state.uncheckedHdrs) : (11 - this.state.uncheckedHdrs) : this.state.allowMultipleDiscount ? (9 - this.state.uncheckedHdrs) : (6 - this.state.uncheckedHdrs)}></td>}
                        <td className="font-weight-bold align-middle ">{helper().translate("REMAINING_DEBT")}:</td>
                        <td className="text-center"><input type="text" className="form-control text-center px-0 " disabled value={helper().formatNumber(this.state.sale?.amountLeft)} ></input></td>
                      </tr>
                      {parseFloat(that.state.totalOtherDetails) > 0 && <tr>
                        {this.state.sale.isDraft ? <td colSpan={this.state.sale.withVat ? this.state.allowMultipleDiscount ? (17 - this.state.uncheckedHdrs) : (14 - this.state.uncheckedHdrs) : this.state.allowMultipleDiscount ? (12 - this.state.uncheckedHdrs) : (9 - this.state.uncheckedHdrs)}></td> : <td colSpan={this.state.sale.withVat ? this.state.allowMultipleDiscount ? (15 - this.state.uncheckedHdrs) : (12 - this.state.uncheckedHdrs) : this.state.allowMultipleDiscount ? (10 - this.state.uncheckedHdrs) : (7 - this.state.uncheckedHdrs)}></td>}
                        <td className="font-weight-bold align-middle ">{helper().translate("OTHER_DETAILS")}:</td>
                        <td className="text-center"><input type="text" className="form-control text-center px-0 " disabled value={helper().formatNumber(that.state.totalOtherDetails)} ></input></td>
                      </tr>}

                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
            {/* <div id="myInv" className="container-fluid px-2 mt-1">
            <Invoice4 saleId={6837} />
            </div> */}
          </div>}

        </div>

        {/*  payment */}
        <div id="payment" className={!this.state.paymentBtn.showPayFrom ? "d-none" : ""}>
          <div className="container-fluid px-2 mt-3">
            <div className="card border-left-primary shadow h-100 mt-1 pt-1 pb-3">
              <div className="container">
                <div className="row font-weight-bold my-4" style={{ height: "30px" }}>
                  <div className="col-12 col-md-2 offset-md-4 d-flex justify-content-center justify-content-md-start">
                    <h6 className="m-0 font-weight-bold text-primary">{helper().translate("PAYMENT")}</h6>
                  </div>
                  <div className="col-2 ">
                    <div className="d-flex justify-content-end">
                      <a className="arrowLeft" onClick={this.onArrowClick} ><i className="fas fa-arrow-left fa-lg" > </i></a>
                    </div>
                  </div>
                </div>
                <div className="row pt-2 font-weight-bold" >
                  <div className=" col-12 col-md-3 offset-md-2 d-flex justify-content-center justify-content-md-start ">
                    <div className="text-left">
                      <p>{helper().translate("PAYMENT_AMOUNT")}:</p>
                    </div>
                  </div>
                  <div className="col-12 col-md-3  d-flex justify-content-center justify-content-md-start ">
                    <input type="text" className="form-control form-control-sm font-weight-bold text-right " disabled value={helper().formatNumber(this.state.payment[0].inputValue)}>
                    </input>
                  </div>
                </div>
                <div className="row pt-2 font-weight-bold" >
                  <div className="col-12 col-md-3 offset-md-2 d-flex justify-content-center justify-content-md-start">
                    <div className="text-left">
                      <p>{helper().translate("CASH")}:</p>
                    </div>
                  </div>
                  <div className="col-12 col-md-3  d-flex justify-content-center justify-content-md-start ">
                    <input type="number" name="payCash" onChange={(e, obj) => that.paymentFieldChange(e, 1)} value={helper().toFixed2("payCash", this.state.payment[1].inputValue)} className="form-control form-control-sm font-weight-bold text-right " >
                    </input>
                  </div>
                </div>
                <div className="row pt-2 " >
                  <div className="col-12 col-md-3 offset-md-2 d-flex justify-content-center justify-content-md-start">
                    <div >
                      <Select styles={styles} openMenuOnFocus={true} onChange={function (e, obj) { that.paymentChange(e, obj, 2) }} value={banksPosOption.find(i => i.value === this.state.payment[2].bankId)} options={banksPosOption} ></Select>
                    </div>
                  </div>
                  <div className="col-12 col-md-3  d-flex justify-content-center justify-content-md-start pt-2 pt-md-0" style={{ height: "40px" }}>
                    <input type="number" min="0" name="payBank1" disabled={this.state.payment[2].disabled} onChange={(e, obj) => that.paymentFieldChange(e, 2)} value={helper().toFixed2("payBank1", this.state.payment[2].inputValue)} className="form-control form-control-sm font-weight-bold text-right " >
                    </input>
                  </div>
                </div>
                <div className="row pt-2 " >
                  <div className="col-12 col-md-3 offset-md-2 d-flex justify-content-center justify-content-md-start">
                    <div>
                      <Select styles={styles} openMenuOnFocus={true} onChange={function (e, obj) { that.paymentChange(e, obj, 3) }} value={banksPosOption.find(i => i.value === this.state.payment[3].bankId)} options={banksPosOption} ></Select>
                    </div>
                  </div>
                  <div className="col-12 col-md-3  d-flex justify-content-center justify-content-md-start pt-2 pt-md-0" style={{ height: "40px" }}>
                    <input type="number" name="payBank2" disabled={this.state.payment[3].disabled} onChange={(e, obj) => that.paymentFieldChange(e, 3)} value={helper().toFixed2("payBank2", this.state.payment[3].inputValue)} className="form-control form-control-sm font-weight-bold text-right " >
                    </input>
                  </div>
                </div>
                <div className="row pt-2 " >
                  <div className="col-12 col-md-3 offset-md-2 d-flex justify-content-center justify-content-md-start">
                    <div >
                      <Select styles={styles} openMenuOnFocus={true} onChange={function (e, obj) { that.paymentChange(e, obj, 4) }} value={banksPosOption.find(i => i.value === this.state.payment[4].bankId)} options={banksPosOption} ></Select>
                    </div>
                  </div>
                  <div className="col-12 col-md-3  d-flex justify-content-center justify-content-md-start pt-2 pt-md-0" style={{ height: "40px" }}>
                    <input type="number" name="payBank3" disabled={this.state.payment[4].disabled} onChange={(e, obj) => that.paymentFieldChange(e, 4)} value={helper().toFixed2("payBank2", this.state.payment[4].inputValue)} className="form-control form-control-sm font-weight-bold text-right " >
                    </input>
                  </div>
                </div>
                <div className="row font-weight-bold pt-2" >
                  <div className="col-12 col-md-3 offset-md-2 d-flex justify-content-center justify-content-md-start">
                    <div className="text-left">
                      <p>{helper().translate("PAYMENT_TOTAL")}:</p>
                    </div>
                  </div>
                  <div className="col-12 col-md-3  d-flex justify-content-center justify-content-md-start  ">
                    <input type="text" value={helper().formatNumber(this.state.payment[5].inputValue)} disabled className="form-control font-weight-bold form-control-sm text-right " >
                    </input>
                  </div>
                </div>
                <div className="row font-weight-bold pt-2" >
                  <div className="col-12 col-md-3 offset-md-2 d-flex justify-content-center justify-content-md-start">
                    <div className="text-left">
                      <p>{helper().translate("REMAINING_DEBT")}:</p>
                    </div>
                  </div>
                  <div className="col-12 col-md-3  d-flex justify-content-center justify-content-md-start  ">
                    <input style={{ color: "red" }} type="text" value={helper().formatNumber(this.state.payment[6].inputValue)} disabled className="form-control font-weight-bold form-control-sm text-right " >
                    </input>
                  </div>
                </div>
                <div className="row font-weight-bold pt-2" >
                  <div className="col-12 col-md-3 offset-md-2 d-flex justify-content-center justify-content-md-start">
                    <div className="text-left">
                      <p>{helper().translate("RETURN_SUM")}:</p>
                    </div>
                  </div>
                  <div className="col-12 col-md-3  d-flex justify-content-center justify-content-md-start">
                    <input style={{ color: "red" }} type="text" value={helper().formatNumber(this.state.payment[7].inputValue)} disabled className="form-control font-weight-bold form-control-sm text-right " >
                    </input>
                  </div>
                </div>
                <div className="row  pt-2 my-4 " >
                  <div className="col-6 ps-0 offset-2 d-flex justify-content-center align-item-center ">
                    <button onClick={this.savePayment} className="btn btn-success ms-3 w-100"><p className="text-capitalize m-0">{helper().translate("SAVE")}</p></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Payments Show */}

        {this.state.paymentBtn.showPayments ?
          <div id="payments" >

            <PaymentSales
              saleId={this.props.match.params.id}
              defaultAccount={this.state.defaultAccount}
              partners={partnerOptions}
              sale={this.state.sale}
              cashBoxId={this.state.currentUserCashBoxId}
              hidePayments={this.hidePayments}
            />

          </div>
          : ''}

        {/* OtherSalesDetails Show */}

        {this.state.otherSalesDetails &&
          <div>
            <div className="container-fluid px-2 mt-3">

              <div className="card border-left-primary shadow h-100 mt-1">
                <div className="card-header py-2"><label className="text-xs font-weight-bold text-primary mb-3">{helper().translate("OTHER_DETAILS")}</label>
                  <div className='d-flex align-items-center justify-content-end'>
                    <button className="btn btn-sm btn-dark btn-transport-save  p-0" style={{ width: "75px" }} onClick={this.onButtonClickOtherSD} >{helper().translate('BACK')}</button>
                    {/* <button   className="btn btn-sm btn-primary btn-transport-save ms-2 p-0" style={{width: "75px"}} onClick={() => addRow()}>{helper().translate('NEW')}</button> */}
                    <button className="btn btn-sm btn-success btn-transport-save ms-2 p-0" style={{ width: "75px" }} onClick={this.saveOtherDetails} >{helper().translate('SAVE')}</button>
                  </div>
                </div>
                <div className="card-body px-2">

                  <table className="table table-hover text-center sales-table purchase-table transpot-table ">
                    <thead>
                      <tr>
                        <th scope="col" style={{ width: '45px' }} >{helper().translate('NR')}</th>
                        <th scope="col" style={{ width: '35vw' }}>{helper().translate('PAYMENTS_INFO')}</th>
                        <th scope="col">{helper().translate('QUANTITY')}</th>
                        <th scope="col">{helper().translate('PRICE')}</th>
                        <th scope="col">{helper().translate('TOTAL')}</th>
                        <th style={{ width: '25px' }}>+</th>
                        <th scope="col" style={{ width: '25px' }}>-</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemSaleOtherDetails.map((item, key) =>
                        <tr key={key}>
                          <td>{item.no}</td>
                          {/* payment info */}
                          {
                            item.editMode ?
                              <td

                                className=' font-weight-bold text-left' >

                                <input
                                  name="paymentsInfo"
                                  // disabled={!findByDate.dateStartDisabled}
                                  className={` form-control form-control-sm text-center  `}
                                  onChange={(e) => that.onOtherFieldChange(e, item.no)}
                                  type="text"
                                  // label={helper().translate("START_DATE")}
                                  value={that.state.itemSaleOtherDetails[item.no - 1].paymentsInfo}
                                /></td>
                              : <td onClick={function () { that.rowClickOtherDetails(item.no) }} className='font-weight-bold'>
                                {item?.id === 0 && item.paymentsInfo === "" ? <span className="text-center text-info small">{helper().translate("ADD_PAYMENT_INFO")}</span> : item?.paymentsInfo}
                              </td>
                          }

                          {/* quantity */}
                          {
                            item.editMode ?
                              <td name="quantity" onClick={function () { that.rowClickOtherDetails(item.no) }}><input name="quantity"
                                className={` form-control form-control-sm text-center  `}
                                type="number"
                                value={that.state.itemSaleOtherDetails[item.no - 1].quantity}
                                onChange={(e) => that.onOtherFieldChange(e, item.no)}></input></td>
                              :
                              <td className={`${item.service !== true && item.isntAllowedQuantity === true ? "is-invalid-i" : ""}`} onClick={function () { that.rowClickOtherDetails(item.no) }}>{item.quantity}</td>
                          }
                          {/* priceforunit */}
                          {item.editMode ?
                            <td><input
                              name="priceForUnit"
                              className="form-control form-control-sm text-center "
                              type="number"
                              value={helper().toFixed2("priceForUnit", that.state.itemSaleOtherDetails[item.no - 1].priceForUnit, true)}

                              onChange={(e) => that.onOtherFieldChange(e, item.no)}></input></td>
                            : (<td onClick={function () { that.rowClickOtherDetails(item.no) }}>{typeof (item.priceForUnit) != 'undefined' ? helper().formatNumber(parseFloat(item.priceForUnit), true) : item.priceForUnit}</td>)}

                          {/* TotalPrice / totali me tvsh*/}

                          {item.editMode ? (<td><input name="totalPrice" className="form-control form-control-sm text-center " type="number" defaultValue={0}
                            value={helper().toFixed2("totalPrice", that.state.itemSaleOtherDetails[item.no - 1].totalPrice, true)}
                            onChange={(e) => that.onOtherFieldChange(e, item.no)}></input></td>) : (<td onClick={function () { that.rowClickOtherDetails(item.no) }}>{typeof (item.totalPrice) != 'undefined' ? helper().formatNumber(parseFloat(item.totalPrice), true) : item.totalPrice}</td>)}

                          {/* Add Btn */}
                          {
                            //that.state.saleDetails[item.no-1].addButton 
                            that.state.itemSaleOtherDetails[item.no - 1].addButton ? <td><button className="btn-edit"
                              onClick={that.addRowOtherDetails}
                            ><span className="icon text-white-40"><i className="fas fa-plus-circle"></i></span></button></td> : <td></td>
                          }


                          {/* Delete btn */}
                          <td><button className="btn-delete"
                            onClick={() => this.alertOnOtherDelete(item.no, item.id)}
                          ><span className="icon text-white-40">
                              <i className="fas fa-minus-circle"></i>
                            </span></button></td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot className="mb-2 mt-2 table-borderless no-colors">
                      <tr>
                        <td colSpan="4"></td>
                        <td className="font-weight-bold">{helper().translate('TOTAL')}:</td>
                      </tr>

                      <tr>
                        <td colSpan="4"></td>
                        <td className="font-weight-bold ">
                          <input style={{ width: '99%' }} type="text" disabled defaultValue="0" className="form-control text-center  pb-1" value={helper().formatNumber(that.state.totalOtherDetails)}  ></input>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

export default withToast(Sale);
